var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.74,141.77l-87.61-.13s4.36-5.67,9.17-6.37c0,0,9.38-27.79,25-28,14.54-.16,20.34,17.13,20.34,17.13s6.74-7.74,13.17-4.19S158.89,134,158.89,134,166.12,137.87,168.74,141.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.08,94.12l110.79.17s0-7.08-15.25-8.49c0,0-13.89-31-35.17-26.83C605.2,61.53,598.4,79.72,598.4,79.72s-10-14.33-18-11.58-12.8,18-12.8,18S559.34,90.12,558.08,94.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.45,90.31l75.34.11s-7.1-6.62-10.26-6.63-12.35-22.23-24.13-21.3S234.33,80,234.33,80,220,75.43,211.45,90.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.75,144.07l64.42.1s-3.2-4.18-6.73-4.7c0,0-6.83-20.46-18.33-20.62-10.69-.15-15,12.55-15,12.55s-4.94-5.71-9.67-3.11S507,138.35,507,138.35,501.68,141.21,499.75,144.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.01 163.76 128.72 163.76 128.72 226.55 142.02 226.55 142.02 191 207.77 191 207.77 247.29 216.47 247.29 216.47 115.2 273.61 115.2 273.61 151.46 302.9 151.46 302.9 196.56 311.77 196.56 311.77 168.2 363.71 168.2 363.71 252.86 378.91 252.86 378.91 184.03 426.42 184.03 426.42 131.76 458.72 131.76 458.72 101.99 496.09 101.99 496.09 234.03 508.65 234.03 508.65 178.93 570.2 178.93 570.2 257.81 578.72 257.81 578.72 193.42 641.14 193.42 641.14 135.42 672.99 135.42 672.99 427.44 77.01 427.44 77.01 163.76",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.35,
    y: 171.66,
    width: 8.75,
    height: 12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.52,
    y: 171.66,
    width: 8.75,
    height: 12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.68,
    y: 171.66,
    width: 8.75,
    height: 12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.35,
    y: 189.72,
    width: 8.75,
    height: 12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.52,
    y: 189.72,
    width: 8.75,
    height: 12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.68,
    y: 189.72,
    width: 8.75,
    height: 12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.35,
    y: 207.78,
    width: 8.75,
    height: 12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.52,
    y: 207.78,
    width: 8.75,
    height: 12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.68,
    y: 207.78,
    width: 8.75,
    height: 12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.35,
    y: 225.84,
    width: 8.75,
    height: 12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.52,
    y: 225.84,
    width: 8.75,
    height: 12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.68,
    y: 225.84,
    width: 8.75,
    height: 12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.21,
    y: 192.61,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.37,
    y: 192.61,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.53,
    y: 192.61,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.21,
    y: 207.68,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.37,
    y: 207.68,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.53,
    y: 207.68,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.21,
    y: 222.75,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.37,
    y: 222.75,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.53,
    y: 222.75,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.21,
    y: 237.82,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.37,
    y: 237.82,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.53,
    y: 237.82,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.21,
    y: 253.26,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.37,
    y: 253.26,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.53,
    y: 253.26,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.21,
    y: 268.7,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.37,
    y: 268.7,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.53,
    y: 268.7,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.21,
    y: 284.14,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.37,
    y: 284.14,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.53,
    y: 284.14,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.21,
    y: 299.58,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.37,
    y: 299.58,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.53,
    y: 299.58,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.49,
    y: 198.7,
    width: 50.36,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.49,
    y: 213.27,
    width: 50.36,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.49,
    y: 227.84,
    width: 50.36,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.49,
    y: 242.41,
    width: 50.36,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.49,
    y: 256.97,
    width: 50.36,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.49,
    y: 271.54,
    width: 50.36,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.49,
    y: 286.11,
    width: 50.36,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.49,
    y: 300.67,
    width: 50.36,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.09,
    y: 185.93,
    width: 46.3,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.09,
    y: 200.5,
    width: 46.3,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.09,
    y: 215.07,
    width: 46.3,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.09,
    y: 229.63,
    width: 46.3,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.09,
    y: 244.2,
    width: 46.3,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.09,
    y: 258.77,
    width: 46.3,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.09,
    y: 273.33,
    width: 46.3,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.09,
    y: 287.9,
    width: 46.3,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.09,
    y: 301.74,
    width: 46.3,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.09,
    y: 315.58,
    width: 46.3,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.09,
    y: 329.43,
    width: 46.3,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.09,
    y: 343.27,
    width: 46.3,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.09,
    y: 357.11,
    width: 46.3,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.35,
    y: 203.53,
    width: 48.91,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.35,
    y: 218.09,
    width: 48.91,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.35,
    y: 232.66,
    width: 48.91,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.35,
    y: 247.23,
    width: 48.91,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.35,
    y: 261.79,
    width: 48.91,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.35,
    y: 276.36,
    width: 48.91,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.35,
    y: 290.93,
    width: 48.91,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.35,
    y: 305.5,
    width: 48.91,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.35,
    y: 318.53,
    width: 48.91,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.35,
    y: 331.57,
    width: 48.91,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.35,
    y: 344.61,
    width: 48.91,
    height: 7.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.97,
    y: 174.99,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.97,
    y: 189.06,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.97,
    y: 203.13,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.97,
    y: 217.2,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.97,
    y: 231.27,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.97,
    y: 245.33,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.97,
    y: 259.4,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.97,
    y: 273.47,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.13,
    y: 174.99,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.13,
    y: 189.06,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.13,
    y: 203.13,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.13,
    y: 217.2,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.13,
    y: 231.27,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.13,
    y: 245.33,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.13,
    y: 259.4,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.13,
    y: 273.47,
    width: 15.55,
    height: 7.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.14,
    y: 122.8,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.29,
    y: 122.8,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.14,
    y: 139.6,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.29,
    y: 139.6,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.14,
    y: 156.4,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.29,
    y: 156.4,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.14,
    y: 173.19,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.29,
    y: 173.19,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.14,
    y: 189.99,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.29,
    y: 189.99,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.14,
    y: 206.78,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.29,
    y: 206.78,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.14,
    y: 223.58,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.29,
    y: 223.58,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.14,
    y: 240.38,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.29,
    y: 240.38,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.23,
    y: 156.4,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.23,
    y: 173.19,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.23,
    y: 189.99,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.23,
    y: 206.78,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.23,
    y: 223.58,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.23,
    y: 240.38,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.14,
    y: 256.97,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.29,
    y: 256.97,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.23,
    y: 256.97,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.14,
    y: 273.57,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.29,
    y: 273.57,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.23,
    y: 273.57,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.14,
    y: 290.16,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.29,
    y: 290.16,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.23,
    y: 290.16,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.14,
    y: 306.76,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.29,
    y: 306.76,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.23,
    y: 306.76,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.14,
    y: 323.36,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.29,
    y: 323.36,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.23,
    y: 323.36,
    width: 16.2,
    height: 11.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.02,
    y: 139.12,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.18,
    y: 139.12,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.02,
    y: 154.19,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.18,
    y: 154.19,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.02,
    y: 169.26,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.18,
    y: 169.26,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.02,
    y: 184.33,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.18,
    y: 184.33,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.02,
    y: 199.77,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.18,
    y: 199.77,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.02,
    y: 215.21,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.18,
    y: 215.21,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.02,
    y: 230.65,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.18,
    y: 230.65,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.02,
    y: 246.1,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.18,
    y: 246.1,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.02,
    y: 261.7,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.18,
    y: 261.7,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.02,
    y: 277.31,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.18,
    y: 277.31,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.02,
    y: 292.91,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.18,
    y: 292.91,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.02,
    y: 308.52,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.18,
    y: 308.52,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.62,
    y: 140.75,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.78,
    y: 140.75,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.62,
    y: 158.5,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.78,
    y: 158.5,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.62,
    y: 176.26,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.78,
    y: 176.26,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.62,
    y: 194.01,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.78,
    y: 194.01,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.62,
    y: 212.2,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.78,
    y: 212.2,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.62,
    y: 230.39,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.78,
    y: 230.39,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.62,
    y: 248.59,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.78,
    y: 248.59,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.62,
    y: 266.78,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.78,
    y: 266.78,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.62,
    y: 285.16,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.78,
    y: 285.16,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.62,
    y: 303.55,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.78,
    y: 303.55,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.62,
    y: 321.93,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.78,
    y: 321.93,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.62,
    y: 340.32,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.78,
    y: 340.32,
    width: 8.75,
    height: 11.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.44,
    y: 139.12,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.6,
    y: 139.12,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.44,
    y: 123.67,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.6,
    y: 123.67,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.44,
    y: 108.22,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.6,
    y: 108.22,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.44,
    y: 154.19,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.6,
    y: 154.19,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.44,
    y: 169.26,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.6,
    y: 169.26,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.44,
    y: 184.33,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.6,
    y: 184.33,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.44,
    y: 199.77,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.6,
    y: 199.77,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.44,
    y: 215.21,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.6,
    y: 215.21,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.44,
    y: 230.65,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.6,
    y: 230.65,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.44,
    y: 246.1,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.6,
    y: 246.1,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.44,
    y: 261.7,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.6,
    y: 261.7,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.44,
    y: 277.31,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.6,
    y: 277.31,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.44,
    y: 292.91,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.6,
    y: 292.91,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.44,
    y: 308.52,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.6,
    y: 308.52,
    width: 8.75,
    height: 10.01,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.28,
    y: 416.8,
    width: 639.43,
    height: 10.58,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.18,416.8a28.23,28.23,0,0,1,0,10.58,28.23,28.23,0,0,1,0-10.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.43,416.8a28.23,28.23,0,0,1,0,10.58,28.23,28.23,0,0,1,0-10.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.67,416.8a28.23,28.23,0,0,1,0,10.58,28.23,28.23,0,0,1,0-10.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.91,416.8a25.62,25.62,0,0,1,.5,5.29,24.37,24.37,0,0,1-.5,5.29,24.37,24.37,0,0,1-.5-5.29A25.62,25.62,0,0,1,202.91,416.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.15,416.8a28.23,28.23,0,0,1,0,10.58,28.23,28.23,0,0,1,0-10.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.39,416.8a28.23,28.23,0,0,1,0,10.58,28.23,28.23,0,0,1,0-10.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.64,416.8a28.23,28.23,0,0,1,0,10.58,28.23,28.23,0,0,1,0-10.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.88,416.8a25.62,25.62,0,0,1,.5,5.29,25,25,0,0,1-.5,5.29,24.37,24.37,0,0,1-.5-5.29A25,25,0,0,1,355.88,416.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.12,416.8a25,25,0,0,1,.5,5.29,24.37,24.37,0,0,1-.5,5.29,25,25,0,0,1-.5-5.29A25.62,25.62,0,0,1,394.12,416.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.36,416.8a28.23,28.23,0,0,1,0,10.58,28.23,28.23,0,0,1,0-10.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.61,416.8a28.23,28.23,0,0,1,0,10.58,28.23,28.23,0,0,1,0-10.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.85,416.8a28.23,28.23,0,0,1,0,10.58,28.23,28.23,0,0,1,0-10.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.09,416.8a25.62,25.62,0,0,1,.5,5.29,24.37,24.37,0,0,1-.5,5.29,24.37,24.37,0,0,1-.5-5.29A25.62,25.62,0,0,1,547.09,416.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.33,416.8a28.23,28.23,0,0,1,0,10.58,28.23,28.23,0,0,1,0-10.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.57,416.8a28.23,28.23,0,0,1,0,10.58,28.23,28.23,0,0,1,0-10.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.82,416.8a28.23,28.23,0,0,1,0,10.58,28.23,28.23,0,0,1,0-10.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.57 427.44 113.68 427.19 200.79 427.1 375 426.94 549.21 427.1 636.32 427.19 723.43 427.44 636.32 427.68 549.21 427.77 375 427.93 200.79 427.77 113.68 427.68 26.57 427.44",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-4--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.08,
    y: 199.02,
    width: 145.54,
    height: 217.79,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 662.23,
    y: 288.01,
    width: 9.93,
    height: 4.2,
    transform: "translate(1334.39 580.22) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 667.77,
    y: 282.72,
    width: 9.93,
    height: 4.2,
    transform: "translate(1345.47 569.63) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 656.69,
    y: 282.72,
    width: 9.93,
    height: 4.2,
    transform: "translate(1323.31 569.63) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.22,
    y: 231.86,
    width: 9.93,
    height: 4.2,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.76,
    y: 237.15,
    width: 9.93,
    height: 4.2,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.19,
    y: 282.72,
    width: 9.93,
    height: 4.2,
    transform: "translate(1106.3 569.63) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.19,
    y: 387.89,
    width: 9.93,
    height: 4.2,
    transform: "translate(1106.3 779.97) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542.65,
    y: 382.6,
    width: 9.93,
    height: 4.2,
    transform: "translate(1095.22 769.39) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 667.77,
    y: 387.88,
    width: 9.93,
    height: 4.2,
    transform: "translate(1345.47 779.96) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.22,
    y: 325.79,
    width: 9.93,
    height: 4.2,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.67,
    y: 331.08,
    width: 9.93,
    height: 4.2,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.73,
    y: 207.76,
    width: 9.93,
    height: 4.2,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.19,
    y: 213.06,
    width: 9.93,
    height: 4.2,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590.63,
    y: 213.06,
    width: 9.93,
    height: 4.2,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.41,
    y: 317.22,
    width: 150.88,
    height: 4.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.41,
    y: 294.9,
    width: 150.88,
    height: 4.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "540.08 317.22 540.08 299.14 685.62 299.14 685.62 317.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.85,282.1a26.08,26.08,0,1,0,26.08,26.08A26.08,26.08,0,0,0,612.85,282.1Zm0,35.12a9,9,0,1,1,9-9A9,9,0,0,1,612.85,317.22Z",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.85,282.1a26.08,26.08,0,1,0,26.08,26.08A26.08,26.08,0,0,0,612.85,282.1Zm0,35.12a9,9,0,1,1,9-9A9,9,0,0,1,612.85,317.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.59,320.82h-2.21a.78.78,0,0,1-.78-.78h0a.78.78,0,0,1,.78-.78h2.21a.78.78,0,0,1,.78.78h0A.78.78,0,0,1,596.59,320.82Z",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.32,304.57h-2.21a.78.78,0,0,1-.78-.78h0a.78.78,0,0,1,.78-.78h2.21a.78.78,0,0,1,.78.78h0A.78.78,0,0,1,628.32,304.57Z",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621,323.81h-2.21A.78.78,0,0,1,618,323h0a.78.78,0,0,1,.78-.78H621a.78.78,0,0,1,.78.78h0A.78.78,0,0,1,621,323.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.34,296h-2.21a.78.78,0,0,1-.78-.78h0a.78.78,0,0,1,.78-.78h2.21a.78.78,0,0,1,.78.78h0A.78.78,0,0,1,596.34,296Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.05,304.45v-2.21a.78.78,0,0,1,.78-.78h0a.78.78,0,0,1,.78.78v2.21a.78.78,0,0,1-.78.78h0A.78.78,0,0,1,600.05,304.45Z",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634,313.78v-2.21a.78.78,0,0,1,.78-.78h0a.78.78,0,0,1,.78.78v2.21a.78.78,0,0,1-.78.78h0A.78.78,0,0,1,634,313.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.84,295.2V293a.78.78,0,0,1,.78-.78h0a.77.77,0,0,1,.77.78v2.21a.77.77,0,0,1-.77.78h0A.78.78,0,0,1,611.84,295.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.59,321.64,604,320.07a.77.77,0,0,1,0-1.1h0a.78.78,0,0,1,1.1,0l1.56,1.56a.78.78,0,0,1,0,1.11h0A.78.78,0,0,1,605.59,321.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.53,297.11,629,295.55a.78.78,0,0,1,0-1.1h0a.77.77,0,0,1,1.1,0l1.57,1.56a.78.78,0,0,1,0,1.1h0A.77.77,0,0,1,630.53,297.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.45,317.9l-1.57-1.57a.78.78,0,0,1,0-1.1h0a.8.8,0,0,1,1.11,0l1.56,1.57a.78.78,0,0,1,0,1.1h0A.78.78,0,0,1,627.45,317.9Z",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.57,291.45,603,289.88a.77.77,0,0,1,0-1.1h0a.78.78,0,0,1,1.1,0l1.56,1.57a.77.77,0,0,1,0,1.1h0A.78.78,0,0,1,604.57,291.45Z",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.83,309.7l1.56-1.56a.77.77,0,0,1,1.1,0h0a.77.77,0,0,1,0,1.1l-1.56,1.56a.77.77,0,0,1-1.1,0h0A.77.77,0,0,1,592.83,309.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.5,328.66l1.57-1.56a.77.77,0,0,1,1.1,0h0a.78.78,0,0,1,0,1.1l-1.56,1.56a.8.8,0,0,1-1.11,0h0A.78.78,0,0,1,610.5,328.66Z",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.56,289.59l1.57-1.56a.77.77,0,0,1,1.1,0h0a.78.78,0,0,1,0,1.1l-1.56,1.56a.78.78,0,0,1-1.11,0h0A.78.78,0,0,1,620.56,289.59Z",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.71,310.32v-5.06a.46.46,0,0,1,.47-.47h1a3,3,0,0,1,0,6h-1A.46.46,0,0,1,643.71,310.32Zm.95-.48h.53a2.05,2.05,0,0,0,0-4.1h-.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.48,305.54a3.17,3.17,0,0,1,0,4.34,2.84,2.84,0,0,1-2.05.91,2.91,2.91,0,0,1-2.1-.91,3.19,3.19,0,0,1,0-4.34,2.85,2.85,0,0,1,2.1-.92A2.77,2.77,0,0,1,654.48,305.54Zm-.11,2.17a2.21,2.21,0,0,0-.59-1.5,1.83,1.83,0,0,0-1.35-.61,1.85,1.85,0,0,0-1.39.61,2.22,2.22,0,0,0,0,3,1.9,1.9,0,0,0,1.39.62,1.88,1.88,0,0,0,1.35-.62A2.2,2.2,0,0,0,654.37,307.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.76,310.32a.48.48,0,0,1-.47.47.47.47,0,0,1-.47-.47v-5h0a.45.45,0,0,1,.19-.39.46.46,0,0,1,.65.1l2.77,3.83v-3.53a.47.47,0,0,1,.47-.46.47.47,0,0,1,.47.46v5a.48.48,0,0,1-.47.47.46.46,0,0,1-.36-.17l0-.05-2.74-3.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.49,310.79a2.46,2.46,0,0,1-2.48-2.47v-3.06a.46.46,0,0,1,.47-.47.48.48,0,0,1,.48.47v3.06a1.53,1.53,0,0,0,3,0v-3.06a.48.48,0,0,1,.48-.47.46.46,0,0,1,.47.47v3.06A2.47,2.47,0,0,1,665.49,310.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.39,305.74H672v4.58a.46.46,0,0,1-.47.47.46.46,0,0,1-.47-.47v-4.58h-1.36a.48.48,0,0,1-.47-.48.47.47,0,0,1,.47-.47h3.66a.48.48,0,0,1,.48.47A.49.49,0,0,1,673.39,305.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675,309.3a.44.44,0,0,1,.62-.06,2.79,2.79,0,0,0,1.64.66,1.84,1.84,0,0,0,1.07-.32.75.75,0,0,0,.37-.61.54.54,0,0,0-.08-.28.84.84,0,0,0-.25-.25,3.4,3.4,0,0,0-1.18-.41h0a4.43,4.43,0,0,1-1.1-.33,1.88,1.88,0,0,1-.8-.67,1.32,1.32,0,0,1-.2-.7,1.59,1.59,0,0,1,.69-1.26,2.54,2.54,0,0,1,1.48-.45,3.3,3.3,0,0,1,1.87.69.44.44,0,0,1-.49.73,2.46,2.46,0,0,0-1.38-.55,1.59,1.59,0,0,0-1,.3.68.68,0,0,0-.32.54.38.38,0,0,0,.06.24,1,1,0,0,0,.23.22,3.11,3.11,0,0,0,1.07.38h0a4.53,4.53,0,0,1,1.18.36,2,2,0,0,1,.86.71,1.35,1.35,0,0,1,.2.73,1.65,1.65,0,0,1-.73,1.33,2.68,2.68,0,0,1-1.59.49,3.75,3.75,0,0,1-2.2-.86A.47.47,0,0,1,675,309.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.77,305.26v5.06a.48.48,0,0,1-.48.47.46.46,0,0,1-.47-.47v-3.61l-1.24,1.72a.45.45,0,0,1-.38.19h0a.47.47,0,0,1-.39-.19l-1.23-1.72v3.61a.48.48,0,0,1-.48.47.47.47,0,0,1-.47-.47v-5.06a.48.48,0,0,1,.47-.47h0a.45.45,0,0,1,.37.2l1.71,2.37L550.9,305a.46.46,0,0,1,.38-.2h0A.49.49,0,0,1,551.77,305.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.91,305.26a.46.46,0,0,1,.47-.47.48.48,0,0,1,.48.47v5.06a.47.47,0,0,1-.48.47.46.46,0,0,1-.47-.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.2,307.71a3.15,3.15,0,0,1,3.15-3.09,3.22,3.22,0,0,1,2,.67.49.49,0,0,1-.6.78,2.14,2.14,0,0,0-1.38-.47,2.31,2.31,0,0,0-1.55.61,2.15,2.15,0,0,0-.62,1.5,2.11,2.11,0,0,0,.62,1.49,2.27,2.27,0,0,0,1.55.62,2.16,2.16,0,0,0,1.38-.48.5.5,0,0,1,.6.79,3.27,3.27,0,0,1-2,.66A3.14,3.14,0,0,1,556.2,307.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.08,310.32v-5.06a.46.46,0,0,1,.47-.47.47.47,0,0,1,.48.47v2.06h2.22v-2.06a.48.48,0,0,1,1,0v5.06a.48.48,0,0,1-1,0v-2.06H564v2.06a.47.47,0,0,1-.48.47A.46.46,0,0,1,563.08,310.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.66,309.38h-2.08l-.42,1.11a.49.49,0,0,1-.45.3.41.41,0,0,1-.16,0,.48.48,0,0,1-.28-.62l1.89-5a.48.48,0,0,1,.46-.3.45.45,0,0,1,.45.3l1.9,5a.5.5,0,0,1-.29.62.39.39,0,0,1-.16,0,.46.46,0,0,1-.44-.3Zm-.35-.94-.69-1.85-.7,1.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.14,310.32v-5.06a.47.47,0,0,1,.48-.47h2.8a.48.48,0,0,1,0,.95H575.1v1.57h2a.49.49,0,0,1,.48.47.48.48,0,0,1-.48.48h-2v1.58h2.32a.48.48,0,0,1,.47.48.48.48,0,0,1-.47.47h-2.8A.47.47,0,0,1,574.14,310.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.23,310.32v-5.06a.48.48,0,0,1,.95,0v4.58h2.33a.48.48,0,0,1,.47.48.48.48,0,0,1-.47.47H579.7A.47.47,0,0,1,579.23,310.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.41,
    y: 224.56,
    width: 150.88,
    height: 4.24,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.41,
    y: 224.56,
    width: 150.88,
    height: 4.24,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.41,
    y: 194.78,
    width: 150.88,
    height: 4.24,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.41,
    y: 194.78,
    width: 150.88,
    height: 4.24,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.41,
    y: 412.56,
    width: 150.88,
    height: 4.24,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.41,
    y: 412.56,
    width: 150.88,
    height: 4.24,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 555.24,
    y: 237.91,
    width: 26.91,
    height: 41.21,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557.43,
    y: 240.1,
    width: 22.53,
    height: 36.82,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "579.96 240.1 579.96 244.54 557.43 267.07 557.43 256.39 573.73 240.1 579.96 240.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "579.96 263.38 579.96 274.05 577.09 276.92 566.42 276.92 579.96 263.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "579.96 258.7 579.96 260.95 563.99 276.92 561.74 276.92 579.96 258.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "571.46 240.1 557.43 254.13 557.43 249.71 567.04 240.1 571.46 240.1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 557.43,
    y: 250.65,
    width: 22.53,
    height: 2.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.4,
    y: 237.91,
    width: 26.91,
    height: 41.21,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.59,
    y: 240.1,
    width: 22.53,
    height: 36.82,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "624.12 240.1 624.12 244.54 601.59 267.07 601.59 256.39 617.88 240.1 624.12 240.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "624.12 263.38 624.12 274.05 621.24 276.92 610.57 276.92 624.12 263.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "624.12 258.7 624.12 260.95 608.14 276.92 605.89 276.92 624.12 258.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "615.61 240.1 601.59 254.13 601.59 249.71 611.2 240.1 615.61 240.1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 601.59,
    y: 250.65,
    width: 22.53,
    height: 2.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.55,
    y: 237.91,
    width: 26.91,
    height: 41.21,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 645.74,
    y: 240.1,
    width: 22.53,
    height: 36.82,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "668.27 240.1 668.27 244.54 645.74 267.07 645.74 256.39 662.03 240.1 668.27 240.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "668.27 263.38 668.27 274.05 665.39 276.92 654.72 276.92 668.27 263.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "668.27 258.7 668.27 260.95 652.29 276.92 650.05 276.92 668.27 258.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "659.77 240.1 645.74 254.13 645.74 249.71 655.35 240.1 659.77 240.1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 645.74,
    y: 250.65,
    width: 22.53,
    height: 2.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 555.24,
    y: 204.51,
    width: 26.91,
    height: 14.94,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557.43,
    y: 206.7,
    width: 22.53,
    height: 10.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "579.96 206.7 579.96 211.14 573.85 217.25 563.17 217.25 573.73 206.7 579.96 206.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "571.46 206.7 560.9 217.25 557.43 217.25 557.43 216.31 567.05 206.7 571.46 206.7",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 599.4,
    y: 204.51,
    width: 26.91,
    height: 14.94,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.59,
    y: 206.7,
    width: 22.53,
    height: 10.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "624.12 206.7 624.12 211.14 618.01 217.25 607.33 217.25 617.89 206.7 624.12 206.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "615.62 206.7 605.06 217.25 601.59 217.25 601.59 216.31 611.21 206.7 615.62 206.7",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 643.56,
    y: 204.51,
    width: 26.91,
    height: 14.94,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 645.75,
    y: 206.7,
    width: 22.53,
    height: 10.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "668.27 206.7 668.27 211.14 662.16 217.25 651.48 217.25 662.04 206.7 668.27 206.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "659.77 206.7 649.21 217.25 645.74 217.25 645.74 216.31 655.36 206.7 659.77 206.7",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 643.2,
    y: 338.2,
    width: 33.62,
    height: 78.6,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.2,
    y: 343.33,
    width: 23.62,
    height: 64.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "671.82 395.69 671.82 406.87 670.57 408.12 659.38 408.12 671.82 395.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "671.82 343.33 671.82 347.14 648.2 370.76 648.2 359.58 664.45 343.33 671.82 343.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "671.82 351.75 671.82 354.11 648.2 377.73 648.2 375.37 671.82 351.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "671.82 377.7 671.82 380.06 648.2 403.68 648.2 401.32 671.82 377.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "654.75 343.33 648.2 349.88 648.2 345.25 650.12 343.33 654.75 343.33",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 673.32,
    y: 383.78,
    width: 2.07,
    height: 6.66,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.2,
    y: 381.62,
    width: 23.62,
    height: 2.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.31 363.9 660.09 350.65 651.58 361.55 651.38 361.4 660.09 350.24 660.19 350.37 670.51 363.75 670.31 363.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.9 374.31 648.8 371.5 650.22 360.84 671.32 363.65 669.9 374.31 669.9 374.31",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669,373.26h-.13l-19-2.53,1.18-8.83h.12l19,2.52Zm-18.81-2.75L668.8,373l1.11-8.34-18.59-2.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.11,366.62a1.49,1.49,0,0,1,1.67-1.24,1.51,1.51,0,0,1,.88.44.22.22,0,0,1,0,.32.25.25,0,0,1-.33,0,1,1,0,0,0-.61-.3,1.09,1.09,0,0,0-.77.19,1,1,0,0,0-.38.65.91.91,0,0,0,.2.72,1.12,1.12,0,0,0,.69.39,1,1,0,0,0,.67-.14.27.27,0,0,1,.32.09.24.24,0,0,1-.08.31,1.52,1.52,0,0,1-1,.19A1.47,1.47,0,0,1,652.11,366.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.18,368.25l.31-2.33a.21.21,0,0,1,.25-.19.23.23,0,0,1,.2.24l-.29,2.12,1.09.15a.23.23,0,0,1,.2.25.24.24,0,0,1-.26.19l-1.3-.18h0A.22.22,0,0,1,655.18,368.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.8,366.62a1.47,1.47,0,0,1,.27,1.05,1.43,1.43,0,0,1-.54.95,1.32,1.32,0,0,1-1,.3,1.39,1.39,0,0,1-.93-.56,1.48,1.48,0,0,1,.27-2,1.35,1.35,0,0,1,1.95.26Zm-.19,1a1,1,0,0,0-.18-.73.84.84,0,0,0-.6-.36.89.89,0,0,0-.69.19,1,1,0,0,0-.36.66,1,1,0,0,0,.18.73.91.91,0,0,0,.61.37.93.93,0,0,0,.68-.2A1,1,0,0,0,659.61,367.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.66,368.5a.22.22,0,0,1,.3,0,1.26,1.26,0,0,0,.72.41.89.89,0,0,0,.53-.08.37.37,0,0,0,.21-.26.27.27,0,0,0,0-.13.34.34,0,0,0-.11-.14,1.66,1.66,0,0,0-.52-.26h0a2.09,2.09,0,0,1-.5-.22.88.88,0,0,1-.33-.36.56.56,0,0,1,0-.34.7.7,0,0,1,.4-.53,1.15,1.15,0,0,1,.72-.12,1.59,1.59,0,0,1,.84.43.21.21,0,0,1,0,.29.2.2,0,0,1-.29,0,1.28,1.28,0,0,0-.61-.34.78.78,0,0,0-.47.08.3.3,0,0,0-.19.23.2.2,0,0,0,0,.11.24.24,0,0,0,.09.12,1.63,1.63,0,0,0,.48.24h0a2.91,2.91,0,0,1,.53.24.93.93,0,0,1,.36.38.6.6,0,0,1,.05.35.75.75,0,0,1-.43.57,1.22,1.22,0,0,1-.77.13,1.78,1.78,0,0,1-1-.53A.22.22,0,0,1,660.66,368.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.37,369.34l.31-2.34a.22.22,0,0,1,.25-.18h0l1.31.17a.22.22,0,1,1-.06.44l-1.09-.14-.1.72.94.13a.21.21,0,0,1,.19.24.23.23,0,0,1-.25.2l-.94-.13-.09.73,1.09.15a.22.22,0,0,1,.19.25.23.23,0,0,1-.25.19l-1.3-.18h0A.22.22,0,0,1,663.37,369.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.76,369.66l.31-2.34a.22.22,0,0,1,.25-.19l.47.07a1.4,1.4,0,1,1-.37,2.77l-.47-.06A.22.22,0,0,1,665.76,369.66Zm.47-.16.25,0a1,1,0,1,0,.25-1.89l-.24,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.8,350.44a.71.71,0,1,1-.71-.71A.71.71,0,0,1,660.8,350.44Z",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.88,
    y: 338.2,
    width: 83.49,
    height: 63.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.96,
    y: 340.36,
    width: 79.34,
    height: 59.12,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "630.3 376.48 630.3 387.66 618.48 399.48 607.29 399.48 630.3 376.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "597.37 340.36 550.96 386.77 550.96 375.58 586.19 340.36 597.37 340.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "604.34 340.36 550.96 393.73 550.96 391.37 601.98 340.36 604.34 340.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "630.3 358.49 630.3 360.84 591.66 399.48 589.3 399.48 630.3 358.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "630.3 391.92 630.3 396.55 627.37 399.48 622.74 399.48 630.3 391.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "576.49 340.36 550.96 365.89 550.96 361.26 571.86 340.36 576.49 340.36",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M558.38,363.55a.26.26,0,0,1,.37,0,3.82,3.82,0,0,0,2.51,1.07,3.63,3.63,0,0,0,1.91-.55,2,2,0,0,0,.92-1.23,1.07,1.07,0,0,0-.47-1.11,4.5,4.5,0,0,0-1.79-.67h0a4.57,4.57,0,0,1-1.81-.69,1.41,1.41,0,0,1-.59-1.45,2.41,2.41,0,0,1,1.13-1.54,3.63,3.63,0,0,1,4.46.36.24.24,0,0,1,0,.36.29.29,0,0,1-.38.07,3.41,3.41,0,0,0-2.1-.87,3.27,3.27,0,0,0-1.75.5,1.77,1.77,0,0,0-.85,1.12,1,1,0,0,0,.43,1,4,4,0,0,0,1.65.62h0a4.9,4.9,0,0,1,2,.76,1.5,1.5,0,0,1,.63,1.54,2.53,2.53,0,0,1-1.22,1.65,4.17,4.17,0,0,1-2.23.65,4.22,4.22,0,0,1-2.81-1.19A.26.26,0,0,1,558.38,363.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.74,362.24l-.28-.06.28.06a3.47,3.47,0,0,1-3.23,2.86h0a2.29,2.29,0,0,1-1.68-.7,2.48,2.48,0,0,1-.66-1.73,2.59,2.59,0,0,1,.05-.54,3.47,3.47,0,0,1,3.23-2.88,2.28,2.28,0,0,1,1.7.72,2.45,2.45,0,0,1,.65,1.72A3.62,3.62,0,0,1,571.74,362.24Zm-.52-.55a1.76,1.76,0,0,0-1.78-1.87h0a2.94,2.94,0,0,0-2.65,2.42,2.09,2.09,0,0,0,0,.43,1.76,1.76,0,0,0,1.78,1.87,2.93,2.93,0,0,0,2.67-2.41A3.27,3.27,0,0,0,571.22,361.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.07,364.76l.47-2.63h0l.46-2.61a.3.3,0,0,1,.33-.24.29.29,0,0,1,.22.34l-.2,1.18a.87.87,0,0,1,.08-.1,3.38,3.38,0,0,1,2.54-1.42.28.28,0,0,1,.28.29.29.29,0,0,1-.28.29,2.63,2.63,0,0,0-1.9,1,6.54,6.54,0,0,0-1,1.38.24.24,0,0,1,0,.07l-.46,2.59a.28.28,0,0,1-.28.24h-.05A.27.27,0,0,1,573.07,364.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.19,364.76l.47-2.63h0l.47-2.61a.28.28,0,0,1,.32-.24.29.29,0,0,1,.22.34l-.2,1.18.09-.1a3.36,3.36,0,0,1,2.53-1.42.28.28,0,0,1,.28.29.29.29,0,0,1-.28.29,2.65,2.65,0,0,0-1.9,1,6.39,6.39,0,0,0-.94,1.38l0,.07-.46,2.59a.28.28,0,0,1-.28.24h-.05A.28.28,0,0,1,578.19,364.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.24,359.52a.14.14,0,0,1,0,.09l-.9,5.09a3.36,3.36,0,0,1-3.19,2.71,2.62,2.62,0,0,1-1.17-.28.31.31,0,0,1-.12-.4.29.29,0,0,1,.38-.11,2,2,0,0,0,.91.21,2.78,2.78,0,0,0,2.63-2.23l.05-.27a2.83,2.83,0,0,1-1.88.76,2.12,2.12,0,0,1-1.47-.56,2,2,0,0,1-.56-1.42,2,2,0,0,1,0-.43l.55-3.18a.3.3,0,0,1,.33-.23.29.29,0,0,1,.23.34l-.56,3.17a1.23,1.23,0,0,0,0,.33,1.39,1.39,0,0,0,1.47,1.42,2.3,2.3,0,0,0,2.16-1.85l.56-3.18a.31.31,0,0,1,.33-.23.26.26,0,0,1,.16.1A.25.25,0,0,1,588.24,359.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.41,359.73l-3.11,5.2a.06.06,0,0,1,0,.05s0,0,0,0l0,0h0l0,0H598l-.07,0h0l0,0v0l0,0a.11.11,0,0,1,0,0s0,0,0-.06l-.77-3.18-1.94,3.26v0s0,0,0,0,0,0,0,0l0,0h-.07s0,0,0,0h-.14l-.07,0h0l0,0v0l0,0a.07.07,0,0,1,0,0,.11.11,0,0,1,0-.06l-1.28-5.21a.28.28,0,0,1,.2-.34.29.29,0,0,1,.35.21l1.12,4.55,1.92-3.22a.27.27,0,0,1,.24-.15.27.27,0,0,1,.29.22l.79,3.15,2.76-4.63a.28.28,0,0,1,.38-.1A.31.31,0,0,1,601.41,359.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.54,362.12a3.48,3.48,0,0,1,3.29-2.87,2.35,2.35,0,0,1,1.72.7,2.49,2.49,0,0,1,.68,1.74c0,.1,0,.2,0,.31s0,0,0,.07a.32.32,0,0,1-.28.23h-4.83a1.38,1.38,0,0,0,0,.35,1.78,1.78,0,0,0,1.83,1.87,2.77,2.77,0,0,0,2.11-1.08.29.29,0,0,1,.41,0,.25.25,0,0,1,0,.38,3.28,3.28,0,0,1-2.55,1.3h0a2.35,2.35,0,0,1-1.72-.7,2.47,2.47,0,0,1-.67-1.74A2.55,2.55,0,0,1,602.54,362.12Zm.7-.41h4.42v0a1.79,1.79,0,0,0-1.83-1.87A2.92,2.92,0,0,0,603.24,361.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.81,358.69a1.14,1.14,0,0,0,.76-.92.33.33,0,0,1-.24-.42l0-.25a.54.54,0,0,1,.49-.39.3.3,0,0,1,.3.39l-.06.3a2.09,2.09,0,0,1-.58,1.24,1.75,1.75,0,0,1-.71.38.14.14,0,0,1-.14-.18A.21.21,0,0,1,609.81,358.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.72,364.76l.47-2.63h0l.46-2.61a.28.28,0,1,1,.55.1l-.2,1.18a.87.87,0,0,1,.08-.1,3.36,3.36,0,0,1,2.53-1.42.28.28,0,0,1,.29.29.29.29,0,0,1-.29.29,2.67,2.67,0,0,0-1.9,1,6.39,6.39,0,0,0-.94,1.38.24.24,0,0,1,0,.07l-.46,2.59a.28.28,0,0,1-.29.24h0A.27.27,0,0,1,612.72,364.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.43,362.12a3.5,3.5,0,0,1,3.3-2.87,2.37,2.37,0,0,1,1.72.7,2.49,2.49,0,0,1,.68,1.74c0,.1,0,.2,0,.31s0,0,0,.07a.32.32,0,0,1-.28.23H618a1.38,1.38,0,0,0,0,.35,1.78,1.78,0,0,0,1.83,1.87,2.77,2.77,0,0,0,2.11-1.08.29.29,0,0,1,.41,0,.25.25,0,0,1,0,.38,3.3,3.3,0,0,1-2.55,1.3h0a2.35,2.35,0,0,1-1.72-.7,2.47,2.47,0,0,1-.67-1.74A3.4,3.4,0,0,1,617.43,362.12Zm.71-.41h4.42v0a1.79,1.79,0,0,0-1.83-1.87A2.92,2.92,0,0,0,618.14,361.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.12,375.59a6.12,6.12,0,0,1,6.11-6,6.2,6.2,0,0,1,3.84,1.3,1,1,0,0,1,.17,1.33,1,1,0,0,1-1.33.18,4.2,4.2,0,0,0-2.68-.91,4.39,4.39,0,0,0-3,1.2,4.07,4.07,0,0,0,0,5.79,4.43,4.43,0,0,0,3,1.19,4.18,4.18,0,0,0,2.68-.91,1,1,0,0,1,1.33.18,1,1,0,0,1-.17,1.33,6.2,6.2,0,0,1-3.84,1.3A6.09,6.09,0,0,1,558.12,375.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.3,380.67v-9.82a.91.91,0,0,1,.91-.91.93.93,0,0,1,.94.91v8.89h4.5a.92.92,0,1,1,0,1.84h-5.44A.91.91,0,0,1,571.3,380.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589,371.38a6.12,6.12,0,0,1,0,8.42,5.46,5.46,0,0,1-4,1.78A5.63,5.63,0,0,1,581,379.8a6.22,6.22,0,0,1,0-8.42A5.56,5.56,0,0,1,585,369.6,5.39,5.39,0,0,1,589,371.38Zm-.22,4.21a4.31,4.31,0,0,0-1.13-2.91,3.59,3.59,0,0,0-5.32,0,4.23,4.23,0,0,0-1.14,2.91,4.19,4.19,0,0,0,1.14,2.9,3.57,3.57,0,0,0,5.32,0A4.27,4.27,0,0,0,588.8,375.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.36,378.69a.86.86,0,0,1,1.21-.12,5.4,5.4,0,0,0,3.18,1.28,3.64,3.64,0,0,0,2.08-.61,1.52,1.52,0,0,0,.72-1.2.92.92,0,0,0-.15-.53,1.48,1.48,0,0,0-.5-.5,6.79,6.79,0,0,0-2.28-.79h0a8.5,8.5,0,0,1-2.14-.64,3.65,3.65,0,0,1-1.55-1.3,2.57,2.57,0,0,1-.38-1.37,3.08,3.08,0,0,1,1.33-2.43,5,5,0,0,1,2.88-.88,6.48,6.48,0,0,1,3.62,1.33.87.87,0,0,1,.24,1.19.84.84,0,0,1-1.18.24,4.88,4.88,0,0,0-2.68-1.06,3.15,3.15,0,0,0-1.87.57,1.3,1.3,0,0,0-.63,1,.84.84,0,0,0,.12.47,1.56,1.56,0,0,0,.45.43,5.58,5.58,0,0,0,2.08.73h0a10.36,10.36,0,0,1,2.3.7,4,4,0,0,1,1.66,1.38,2.71,2.71,0,0,1,.4,1.42,3.23,3.23,0,0,1-1.43,2.58,5.22,5.22,0,0,1-3.08.95,7.19,7.19,0,0,1-4.26-1.67A.88.88,0,0,1,593.36,378.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.65,380.67v-9.82a.9.9,0,0,1,.92-.91H611a.91.91,0,0,1,.91.91.93.93,0,0,1-.91.93H606.5v3.05h3.88a.92.92,0,0,1,0,1.84H606.5v3.07H611a.92.92,0,0,1,0,1.84h-5.44A.91.91,0,0,1,604.65,380.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.35,380.67v-9.82a.9.9,0,0,1,.92-.91h2a5.82,5.82,0,0,1,0,11.64h-2A.91.91,0,0,1,614.35,380.67Zm1.85-.93h1a4,4,0,0,0,0-8h-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.47,
    y: 338.24,
    width: 0.28,
    height: 20.19,
    transform: "translate(-46.27 103.75) rotate(-8.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.72,358.31a.55.55,0,0,1-.55.54.54.54,0,0,1-.54-.54.55.55,0,0,1,.54-.55A.55.55,0,0,1,643.72,358.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.24,
    y: 348.2,
    width: 20.19,
    height: 0.28,
    transform: "translate(229.61 964.88) rotate(-81.13)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.22,358.31a.55.55,0,0,0,.55.54.54.54,0,0,0,.54-.54.55.55,0,0,0-.54-.55A.55.55,0,0,0,676.22,358.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.44,338.21H639.5a38.71,38.71,0,0,0,4.78-12.42h31.38A38.71,38.71,0,0,0,680.44,338.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.44,338.21v1.47A1.3,1.3,0,0,1,679.2,341h-2.64a1.24,1.24,0,1,0-2.47,0h-2.65a1.24,1.24,0,1,0-2.47,0h-2.65a1.24,1.24,0,1,0-2.47,0h-2.64a1.25,1.25,0,1,0-2.48,0h-2.64a1.24,1.24,0,1,0-2.47,0H651a1.24,1.24,0,1,0-2.47,0h-2.65a1.24,1.24,0,1,0-2.47,0h-2.64a1.3,1.3,0,0,1-1.24-1.36v-1.47Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-3--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 399.35,
    y: 276.07,
    width: 140.73,
    height: 140.73,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.09,
    y: 412.55,
    width: 145.16,
    height: 4.24,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.13,
    y: 271.89,
    width: 145.16,
    height: 4.24,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.73,
    y: 398.63,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.19,
    y: 403.92,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.27,
    y: 403.92,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.77,
    y: 403.92,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.77,
    y: 284.75,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.31,
    y: 290.04,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.19,
    y: 284.76,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.74,
    y: 330.28,
    width: 9.93,
    height: 4.2,
    transform: "translate(883.42 664.75) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.28,
    y: 324.98,
    width: 9.93,
    height: 4.2,
    transform: "translate(894.5 654.17) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.67,
    y: 228.15,
    width: 124.09,
    height: 4.24,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.81,
    y: 232.3,
    width: 117.82,
    height: 39.59,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.27,
    y: 247.28,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.81,
    y: 241.98,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.27,
    y: 247.28,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.81,
    y: 257.86,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.11,
    y: 257.86,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.69,
    y: 242.25,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.15,
    y: 237.04,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.47,
    y: 238.74,
    width: 17.44,
    height: 26.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.89,
    y: 240.16,
    width: 14.6,
    height: 23.87,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "440.08 240.16 425.89 254.35 425.89 243.67 429.4 240.16 440.08 240.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.5 258.58 440.5 264.03 435.04 264.03 440.5 258.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.5 253.9 440.5 256.15 432.62 264.03 430.37 264.03 440.5 253.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.14 240.16 425.89 241.41 425.89 240.16 427.14 240.16",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 425.89,
    y: 256.4,
    width: 14.6,
    height: 1.42,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.99,
    y: 238.74,
    width: 17.44,
    height: 26.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.41,
    y: 240.16,
    width: 14.6,
    height: 23.87,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "476.6 240.16 462.41 254.35 462.41 243.67 465.92 240.16 476.6 240.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.02 258.58 477.02 264.03 471.56 264.03 477.02 258.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.02 253.9 477.02 256.15 469.14 264.03 466.89 264.03 477.02 253.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.66 240.16 462.41 241.41 462.41 240.16 463.66 240.16",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 462.41,
    y: 256.4,
    width: 14.6,
    height: 1.42,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.52,
    y: 238.74,
    width: 17.44,
    height: 26.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.94,
    y: 240.16,
    width: 14.6,
    height: 23.87,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "513.13 240.16 498.94 254.35 498.94 243.67 502.45 240.16 513.13 240.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "513.55 258.58 513.55 264.03 508.09 264.03 513.55 258.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "513.55 253.9 513.55 256.15 505.67 264.03 503.42 264.03 513.55 253.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "500.19 240.16 498.94 241.41 498.94 240.16 500.19 240.16",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 498.94,
    y: 256.4,
    width: 14.6,
    height: 1.42,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.43,
    y: 338.14,
    width: 33.62,
    height: 78.6,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.43,
    y: 343.26,
    width: 23.62,
    height: 53,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "436.05 343.26 436.05 347.92 412.43 371.54 412.43 360.35 429.51 343.26 436.05 343.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.05 367.67 436.05 378.85 418.68 396.26 412.43 396.26 412.43 391.32 436.05 367.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.05 362.76 436.05 365.12 412.43 388.78 412.43 386.41 436.05 362.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.14 343.26 412.43 357.97 412.43 353.34 422.51 343.26 427.14 343.26",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 437.55,
    y: 378.92,
    width: 1.63,
    height: 8.84,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.43,
    y: 381.46,
    width: 23.62,
    height: 3.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.17,
    y: 338.14,
    width: 81.79,
    height: 59.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.49,
    y: 340.46,
    width: 77.14,
    height: 54.92,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "529.63 379.84 529.63 391.02 525.27 395.38 514.08 395.38 529.63 379.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "499.96 340.46 452.49 387.93 452.49 376.74 488.78 340.46 499.96 340.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "506.93 340.46 452.49 394.9 452.49 392.53 504.57 340.46 506.93 340.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "529.63 361.85 529.63 364.2 498.45 395.38 496.09 395.38 529.63 361.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "529.63 395.28 529.63 395.38 529.53 395.38 529.63 395.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.08 340.46 452.49 367.05 452.49 362.42 474.45 340.46 479.08 340.46",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 447.55,
    y: 364.14,
    width: 87.01,
    height: 13.9,
    transform: "matrix(0.98, -0.18, 0.18, 0.98, -57.88, 92.69)",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.67,374.32a3.49,3.49,0,0,1,2.86-4,3.61,3.61,0,0,1,2.31.33.54.54,0,0,1,.22.72.55.55,0,0,1-.73.24,2.45,2.45,0,0,0-1.61-.24,2.58,2.58,0,0,0-1.58,1,2.3,2.3,0,0,0,.58,3.23,2.65,2.65,0,0,0,1.82.36,2.5,2.5,0,0,0,1.43-.78.58.58,0,0,1,.77,0,.56.56,0,0,1,0,.76,3.67,3.67,0,0,1-2,1.12A3.49,3.49,0,0,1,472.67,374.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.64,375.81l-1-5.48a.52.52,0,0,1,.43-.6.52.52,0,0,1,.61.42l.89,5,2.56-.46a.52.52,0,1,1,.18,1l-3.05.55h0A.52.52,0,0,1,480.64,375.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.75,368.83a3.42,3.42,0,0,1,.84,4.69,3.2,3.2,0,0,1-2.08,1.4,3.25,3.25,0,0,1-2.48-.58,3.44,3.44,0,0,1-1.36-2.18,3.4,3.4,0,0,1,.52-2.51,3.18,3.18,0,0,1,2.12-1.41A3.14,3.14,0,0,1,489.75,368.83Zm.29,2.37a2.41,2.41,0,0,0-.93-1.51,2.08,2.08,0,0,0-3,.54,2.41,2.41,0,0,0,.58,3.24,2.07,2.07,0,0,0,3-.54A2.33,2.33,0,0,0,490,371.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.93,372.46a.51.51,0,0,1,.68-.19,3.14,3.14,0,0,0,1.93.39,2,2,0,0,0,1.11-.55.86.86,0,0,0,.29-.75.57.57,0,0,0-.14-.28.79.79,0,0,0-.33-.22,3.78,3.78,0,0,0-1.37-.21h0a5.69,5.69,0,0,1-1.28-.15,2.1,2.1,0,0,1-1-.56,1.47,1.47,0,0,1-.35-.73,1.74,1.74,0,0,1,.51-1.49,2.91,2.91,0,0,1,1.54-.78,3.81,3.81,0,0,1,2.19.37.49.49,0,0,1,.25.64.48.48,0,0,1-.64.26,2.76,2.76,0,0,0-1.63-.32,1.86,1.86,0,0,0-1,.5.76.76,0,0,0-.25.65.48.48,0,0,0,.11.25,1,1,0,0,0,.3.19,3.19,3.19,0,0,0,1.25.2h0a5.33,5.33,0,0,1,1.37.15,2.3,2.3,0,0,1,1.08.6,1.52,1.52,0,0,1,.37.75,1.8,1.8,0,0,1-.55,1.58,3,3,0,0,1-1.65.85,4.19,4.19,0,0,1-2.58-.5A.49.49,0,0,1,492.93,372.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.53,372.41l-1-5.47a.5.5,0,0,1,.42-.6h0l3.05-.55a.52.52,0,0,1,.19,1l-2.55.46.3,1.7,2.2-.4a.54.54,0,0,1,.61.42.53.53,0,0,1-.43.61l-2.2.4.31,1.71,2.56-.46a.52.52,0,1,1,.18,1l-3.05.54h0A.52.52,0,0,1,499.53,372.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505,371.43,504,366a.51.51,0,0,1,.42-.6l1.12-.2a3.3,3.3,0,1,1,1.16,6.49l-1.11.2A.52.52,0,0,1,505,371.43Zm1-.71.59-.11a2.25,2.25,0,1,0-.8-4.43l-.58.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.25 369.57 455.27 384.59 453.03 384.99 458.02 369.97 460.25 369.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.41 368.64 460.42 383.66 458.19 384.06 463.18 369.04 465.41 368.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "523.93 358.13 518.94 373.15 516.72 373.55 521.71 358.53 523.93 358.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "529.09 357.2 524.1 372.22 521.88 372.62 526.87 357.6 529.09 357.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.55,
    y: 364.14,
    width: 87.01,
    height: 13.9,
    transform: "matrix(0.98, -0.18, 0.18, 0.98, -57.88, 92.69)",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.67,374.32a3.49,3.49,0,0,1,2.86-4,3.61,3.61,0,0,1,2.31.33.54.54,0,0,1,.22.72.55.55,0,0,1-.73.24,2.45,2.45,0,0,0-1.61-.24,2.58,2.58,0,0,0-1.58,1,2.3,2.3,0,0,0,.58,3.23,2.65,2.65,0,0,0,1.82.36,2.5,2.5,0,0,0,1.43-.78.58.58,0,0,1,.77,0,.56.56,0,0,1,0,.76,3.67,3.67,0,0,1-2,1.12A3.49,3.49,0,0,1,472.67,374.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.64,375.81l-1-5.48a.52.52,0,0,1,.43-.6.52.52,0,0,1,.61.42l.89,5,2.56-.46a.52.52,0,1,1,.18,1l-3.05.55h0A.52.52,0,0,1,480.64,375.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.75,368.83a3.42,3.42,0,0,1,.84,4.69,3.2,3.2,0,0,1-2.08,1.4,3.25,3.25,0,0,1-2.48-.58,3.44,3.44,0,0,1-1.36-2.18,3.4,3.4,0,0,1,.52-2.51,3.18,3.18,0,0,1,2.12-1.41A3.14,3.14,0,0,1,489.75,368.83Zm.29,2.37a2.41,2.41,0,0,0-.93-1.51,2.08,2.08,0,0,0-3,.54,2.41,2.41,0,0,0,.58,3.24,2.07,2.07,0,0,0,3-.54A2.33,2.33,0,0,0,490,371.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.93,372.46a.51.51,0,0,1,.68-.19,3.14,3.14,0,0,0,1.93.39,2,2,0,0,0,1.11-.55.86.86,0,0,0,.29-.75.57.57,0,0,0-.14-.28.79.79,0,0,0-.33-.22,3.78,3.78,0,0,0-1.37-.21h0a5.69,5.69,0,0,1-1.28-.15,2.1,2.1,0,0,1-1-.56,1.47,1.47,0,0,1-.35-.73,1.74,1.74,0,0,1,.51-1.49,2.91,2.91,0,0,1,1.54-.78,3.81,3.81,0,0,1,2.19.37.49.49,0,0,1,.25.64.48.48,0,0,1-.64.26,2.76,2.76,0,0,0-1.63-.32,1.86,1.86,0,0,0-1,.5.76.76,0,0,0-.25.65.48.48,0,0,0,.11.25,1,1,0,0,0,.3.19,3.19,3.19,0,0,0,1.25.2h0a5.33,5.33,0,0,1,1.37.15,2.3,2.3,0,0,1,1.08.6,1.52,1.52,0,0,1,.37.75,1.8,1.8,0,0,1-.55,1.58,3,3,0,0,1-1.65.85,4.19,4.19,0,0,1-2.58-.5A.49.49,0,0,1,492.93,372.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.53,372.41l-1-5.47a.5.5,0,0,1,.42-.6h0l3.05-.55a.52.52,0,0,1,.19,1l-2.55.46.3,1.7,2.2-.4a.54.54,0,0,1,.61.42.53.53,0,0,1-.43.61l-2.2.4.31,1.71,2.56-.46a.52.52,0,1,1,.18,1l-3.05.54h0A.52.52,0,0,1,499.53,372.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505,371.43,504,366a.51.51,0,0,1,.42-.6l1.12-.2a3.3,3.3,0,1,1,1.16,6.49l-1.11.2A.52.52,0,0,1,505,371.43Zm1-.71.59-.11a2.25,2.25,0,1,0-.8-4.43l-.58.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.25 369.57 455.27 384.59 453.03 384.99 458.02 369.97 460.25 369.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.41 368.64 460.42 383.66 458.19 384.06 463.18 369.04 465.41 368.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "523.93 358.13 518.94 373.15 516.72 373.55 521.71 358.53 523.93 358.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "529.09 357.2 524.1 372.22 521.88 372.62 526.87 357.6 529.09 357.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.69,
    cy: 307.46,
    rx: 58.13,
    ry: 20.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.69,324.23c-30,0-54.43-7.53-54.43-16.77s24.42-16.78,54.43-16.78,54.43,7.53,54.43,16.78S499.71,324.23,469.69,324.23Zm0-33.3c-29.87,0-54.18,7.41-54.18,16.53S439.82,324,469.69,324s54.18-7.41,54.18-16.52S499.57,290.93,469.69,290.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.71,312.1h-4.64a.31.31,0,0,1-.26-.36l1.47-8.31a.3.3,0,0,1,.36-.26.32.32,0,0,1,.25.36l-1.4,8h4.22a.32.32,0,0,1,.32.31A.31.31,0,0,1,428.71,312.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.75,309.76l-1.19,2.16a.31.31,0,0,1-.27.17.42.42,0,0,1-.15,0,.33.33,0,0,1-.13-.42l4.6-8.32a.31.31,0,0,1,.28-.17.33.33,0,0,1,.32.26l1.66,8.31a.34.34,0,0,1-.24.38h-.07a.3.3,0,0,1-.3-.26l-.41-2.07Zm3-5.44-2.67,4.81h3.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.54,303.5l-.9,5a4.4,4.4,0,0,1-4.17,3.56h0a3.09,3.09,0,0,1-2.2-.87,3,3,0,0,1-.87-2.17,3.34,3.34,0,0,1,.06-.62l.88-5a.31.31,0,1,1,.62.11l-.89,5a3.26,3.26,0,0,0-.05.52,2.37,2.37,0,0,0,2.47,2.42,3.8,3.8,0,0,0,3.56-3l.89-5a.33.33,0,0,1,.36-.26A.33.33,0,0,1,447.54,303.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.11,303.43a0,0,0,0,0,0,0,.31.31,0,0,1,.15-.25.3.3,0,0,1,.42.13l4.11,7.54,1.31-7.4a.31.31,0,0,1,.35-.26.32.32,0,0,1,.26.37l-1.46,8.26a.3.3,0,0,1-.3.26h-.05a.32.32,0,0,1-.23-.15.06.06,0,0,0,0-.05l-4.07-7.49-1.32,7.43a.3.3,0,0,1-.31.26h0a.32.32,0,0,1-.25-.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.62,311.73l1.47-8.32a.3.3,0,0,1,.3-.25h1.68a3.8,3.8,0,0,1,2.73,1.07,3.72,3.72,0,0,1,1.06,2.67,7,7,0,0,1-.06.78,5.5,5.5,0,0,1-5.2,4.42h-1.73A.33.33,0,0,1,459.62,311.73Zm.69-.26h1.29a4.87,4.87,0,0,0,4.58-3.89,4,4,0,0,0,.05-.68,3,3,0,0,0-3.16-3.12h-1.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.86,308.64a2.78,2.78,0,0,0-.85-.39h-2.27l-.62,3.58a.34.34,0,0,1-.31.26.07.07,0,0,1-.06,0,.32.32,0,0,1-.26-.36L470,303.4a.33.33,0,0,1,.32-.26h2.52a2.2,2.2,0,0,1,1.57.63,2.13,2.13,0,0,1,.62,1.53,3.29,3.29,0,0,1,0,.45,3.18,3.18,0,0,1-1.88,2.29,1.91,1.91,0,0,1,1,1.67c0,.14,0,.28,0,.42a3.78,3.78,0,0,0-.09.78,1,1,0,0,0,.06.41.33.33,0,0,1,.33.23.31.31,0,0,1-.21.38.32.32,0,0,1-.14,0h0a.61.61,0,0,1-.46-.26,1.32,1.32,0,0,1-.19-.79,5.66,5.66,0,0,1,.09-.89,1.15,1.15,0,0,0,0-.31A1.3,1.3,0,0,0,472.86,308.64Zm-3-1H472a2.5,2.5,0,0,0,2.33-2,2.07,2.07,0,0,0,0-.35,1.49,1.49,0,0,0-1.57-1.53h-2.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.7,304.22a3.78,3.78,0,0,1,1,2.63,4.76,4.76,0,0,1-.08.83l-.3-.06.3.06a5.33,5.33,0,0,1-4.95,4.41A3.5,3.5,0,0,1,477.1,311a3.77,3.77,0,0,1-1-2.64,4.85,4.85,0,0,1,.08-.83,5.35,5.35,0,0,1,5-4.42A3.46,3.46,0,0,1,483.7,304.22Zm.37,2.63a2.9,2.9,0,0,0-2.93-3.08h0a4.74,4.74,0,0,0-4.32,3.91,5.83,5.83,0,0,0-.06.71,2.91,2.91,0,0,0,2.94,3.08,4.74,4.74,0,0,0,4.34-3.91A4.34,4.34,0,0,0,484.07,306.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.74,307.64a.23.23,0,0,1,.25-.23h2.71a.24.24,0,0,1,.25.23.26.26,0,0,1-.25.26H487A.24.24,0,0,1,486.74,307.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.26,311.74l1.29-7.27-3.56,4a.31.31,0,0,1-.24.1h0a.3.3,0,0,1-.27-.16l-2.17-4L493,311.84a.3.3,0,0,1-.31.26h-.06a.32.32,0,0,1-.25-.36l1.46-8.31a.31.31,0,0,1,.32-.26.33.33,0,0,1,.3.15l2.37,4.4,4-4.45a.28.28,0,0,1,.24-.1h.06a.3.3,0,0,1,.26.36l-1.47,8.31a.29.29,0,0,1-.3.26h-.06A.32.32,0,0,1,499.26,311.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.45,309.76l-1.18,2.16a.33.33,0,0,1-.27.17.42.42,0,0,1-.15,0,.31.31,0,0,1-.13-.42l4.6-8.32a.3.3,0,0,1,.28-.17.33.33,0,0,1,.32.26l1.66,8.31a.34.34,0,0,1-.25.38h-.06a.32.32,0,0,1-.31-.26l-.41-2.07Zm3-5.44-2.67,4.81h3.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511,311.7l1.39-7.94h-2.63a.32.32,0,0,1,0-.63h6a.32.32,0,0,1,0,.63H513l-1.42,8.06a.31.31,0,0,1-.31.25h0A.29.29,0,0,1,511,311.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-2--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.74,
    y: 259.01,
    width: 134.61,
    height: 157.79,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.1,
    y: 274.01,
    width: 9.93,
    height: 4.2,
    transform: "translate(758.14 552.22) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.64,
    y: 268.72,
    width: 9.93,
    height: 4.2,
    transform: "translate(769.22 541.63) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.56,
    y: 268.72,
    width: 9.93,
    height: 4.2,
    transform: "translate(747.06 541.63) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.06,
    y: 268.72,
    width: 9.93,
    height: 4.2,
    transform: "translate(570.05 541.63) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.06,
    y: 387.89,
    width: 9.93,
    height: 4.2,
    transform: "translate(570.05 779.97) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.52,
    y: 382.6,
    width: 9.93,
    height: 4.2,
    transform: "translate(558.97 769.39) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.64,
    y: 387.88,
    width: 9.93,
    height: 4.2,
    transform: "translate(769.22 779.96) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.09,
    y: 318.36,
    width: 9.93,
    height: 4.2,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.55,
    y: 323.65,
    width: 9.93,
    height: 4.2,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.28,
    y: 307.22,
    width: 141.54,
    height: 4.24,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.28,
    y: 307.22,
    width: 141.54,
    height: 4.24,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.28,
    y: 284.9,
    width: 141.54,
    height: 4.24,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.28,
    y: 284.9,
    width: 141.54,
    height: 4.24,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.74,
    y: 289.14,
    width: 134.61,
    height: 18.08,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.54,302.77h0a.31.31,0,0,1-.31-.31v-8.31a.32.32,0,0,1,.63,0v8h4.33a.32.32,0,1,1,0,.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.94,294.15a.32.32,0,0,1,.63,0v8.31a.32.32,0,0,1-.63,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.09,294.15a.31.31,0,0,1,.31-.3h2a2.24,2.24,0,0,1,2.25,2.23,2.21,2.21,0,0,1-.87,1.73,2.54,2.54,0,0,1-.81,5h-2.6a.3.3,0,0,1-.3-.31Zm2.33,3.51a1.6,1.6,0,1,0,0-3.19h-1.7v3.19Zm.57,4.48a1.93,1.93,0,1,0,0-3.85h-2.27v3.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.57,300.75a1.59,1.59,0,0,0-.74-1.35,2.81,2.81,0,0,0-1-.44l-.07,0h-2.2v3.53a.32.32,0,0,1-.63,0v-8.31a.31.31,0,0,1,.28-.3h2.59a2.54,2.54,0,0,1,1.09,4.85.52.52,0,0,0,.13.06,2.28,2.28,0,0,1,1.21,2,3.25,3.25,0,0,0,.12,1,.43.43,0,0,0,.13.21.35.35,0,0,1,.35.21.34.34,0,0,1-.21.4l-.15,0h0a.72.72,0,0,1-.58-.41A3.06,3.06,0,0,1,331.57,300.75Zm-1.81-6.28h-2.24v3.85h2.29a1.93,1.93,0,0,0-.05-3.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.41,300.46h-4.13l-.8,2.1a.32.32,0,0,1-.3.21l-.12,0a.32.32,0,0,1-.18-.4l3.15-8.27a.34.34,0,0,1,.31-.2.32.32,0,0,1,.31.2l3.14,8.27a.3.3,0,0,1-.17.4l-.11,0a.33.33,0,0,1-.3-.21Zm-3.9-.62h3.66l-1.82-4.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.61,300.75a1.62,1.62,0,0,0-.74-1.35,2.77,2.77,0,0,0-1.05-.44l-.06,0h-2.2v3.53a.32.32,0,0,1-.33.31.32.32,0,0,1-.31-.31v-8.31a.31.31,0,0,1,.29-.3h2.59a2.54,2.54,0,0,1,1.08,4.85.52.52,0,0,0,.13.06,2.27,2.27,0,0,1,1.22,2,3.68,3.68,0,0,0,.11,1,.53.53,0,0,0,.13.21.32.32,0,0,1,.15.61l-.16,0h0a.73.73,0,0,1-.58-.41A3.22,3.22,0,0,1,350.61,300.75Zm-1.81-6.28h-2.24v3.85h2.29a1.93,1.93,0,0,0-.05-3.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.65,298.48l-3-4.09a.32.32,0,0,1,.06-.43.3.3,0,0,1,.44.05l2.83,3.84,2.85-3.84a.3.3,0,0,1,.44-.05.29.29,0,0,1,.06.43l-3,4.07v4a.31.31,0,0,1-.31.31.31.31,0,0,1-.31-.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.28,
    y: 256.9,
    width: 141.54,
    height: 4.24,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.28,
    y: 256.9,
    width: 141.54,
    height: 4.24,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.28,
    y: 412.56,
    width: 141.54,
    height: 4.24,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.28,
    y: 412.56,
    width: 141.54,
    height: 4.24,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.79,
    y: 315.15,
    width: 33.62,
    height: 19.03,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "394.41 315.15 394.41 324.19 384.42 334.18 373.24 334.18 392.26 315.15 394.41 315.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.48 315.15 362.45 334.18 360.79 334.18 360.79 333.47 379.12 315.15 381.48 315.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.19 315.15 360.79 327.55 360.79 322.92 368.56 315.15 373.19 315.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.41 327.41 394.41 332.04 392.27 334.18 387.64 334.18 394.41 327.41",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 360.79,
    y: 338.2,
    width: 33.62,
    height: 78.6,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 343.33,
    width: 23.62,
    height: 38.6,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 343.33,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 344.56,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 345.79,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 347.01,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 348.24,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 349.47,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 350.7,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 351.93,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 353.16,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 354.39,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 355.62,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 356.85,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 358.08,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 359.31,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 360.54,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 361.77,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 363,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 364.23,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 365.46,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 366.69,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 367.91,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 369.14,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.79,
    y: 370.37,
    width: 23.62,
    height: 0.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "389.41 343.33 389.41 347.98 365.79 371.6 365.79 360.41 382.88 343.33 389.41 343.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.41 367.73 389.41 378.91 386.39 381.93 375.21 381.93 389.41 367.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.41 362.83 389.41 365.19 372.67 381.93 370.31 381.93 389.41 362.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.5 343.33 365.79 358.03 365.79 353.4 375.87 343.33 380.5 343.33",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 367.9,
    y: 386.29,
    width: 17.7,
    height: 4.14,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.08,
    y: 383.78,
    width: 2.07,
    height: 6.66,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.79,410.24c-.07-1.13-.11-2.26-.16-3.39s-.08-2.27-.11-3.4c-.06-2.26-.1-4.53-.12-6.79v-.39h.39c1.78,0,3.56,0,5.33,0s3.56,0,5.33,0,3.56.07,5.33.13c.89,0,1.78.06,2.67.1s1.78.07,2.67.13l-2.67.13c-.89,0-1.78.08-2.67.1-1.77.06-3.55.1-5.33.12s-3.55.05-5.33.05-3.55,0-5.33,0l.39-.39c0,2.26-.05,4.53-.11,6.79,0,1.13-.07,2.27-.12,3.4S365.86,409.11,365.79,410.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.41,396.66c.07,1.13.11,2.26.16,3.4s.08,2.26.12,3.39c.06,2.27.09,4.53.12,6.79v.4h-.4c-1.79,0-3.59,0-5.38,0s-3.59,0-5.39,0-3.59-.07-5.38-.12l-2.7-.11c-.89,0-1.79-.07-2.69-.13l2.69-.13c.9,0,1.8-.08,2.7-.1,1.79-.06,3.59-.09,5.38-.12s3.59-.05,5.39-.05,3.59,0,5.38,0l-.39.39c0-2.26.06-4.52.12-6.79,0-1.13.06-2.26.12-3.39S389.34,397.79,389.41,396.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.85,407.68c-.12-1.41-.19-2.82-.25-4.23,0-.7-.05-1.41-.08-2.11s0-1.41,0-2.12v-.37h.38c1.32,0,2.64,0,3.95,0s2.63,0,3.95.05,2.63.06,3.95.12,2.63.13,3.95.24c-1.32.11-2.63.19-3.95.24s-2.63.1-3.95.13-2.63,0-3.95,0-2.63,0-3.95,0l.38-.38c0,.71,0,1.41-.05,2.12s0,1.41-.07,2.11C369.05,404.86,369,406.27,368.85,407.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.35,399.22c.12,1.41.2,2.82.25,4.23s.1,2.82.13,4.23v.37h-.38c-1.33,0-2.66,0-4,0s-2.66,0-4,0-2.66-.07-4-.12-2.66-.14-4-.25q2-.17,4-.24t4-.12c1.33,0,2.66,0,4-.05s2.66,0,4,0l-.37.37q0-2.12.12-4.23C386.16,402,386.24,400.63,386.35,399.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.47,
    y: 312.99,
    width: 83.49,
    height: 75.54,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.55,
    y: 315.15,
    width: 79.34,
    height: 71.22,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "351.89 363.37 351.89 374.55 340.07 386.37 328.88 386.37 351.89 363.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.06 315.15 272.55 373.66 272.55 362.48 319.88 315.15 331.06 315.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.03 315.15 272.55 380.63 272.55 378.27 335.67 315.15 338.03 315.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.89 345.38 351.89 347.74 313.25 386.37 310.9 386.37 351.89 345.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.89 378.82 351.89 383.44 348.96 386.37 344.33 386.37 351.89 378.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.18 315.15 272.55 352.78 272.55 348.15 305.55 315.15 310.18 315.15",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 267.9,
    y: 329.76,
    width: 0.41,
    height: 29.58,
    transform: "translate(-50.21 45.76) rotate(-8.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.2,359.17a.8.8,0,1,1-.8-.8A.8.8,0,0,1,271.2,359.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.46,
    y: 344.35,
    width: 29.58,
    height: 0.41,
    transform: "translate(-39.17 643.34) rotate(-81.12)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.16,359.17a.8.8,0,1,0,.8-.8A.8.8,0,0,0,353.16,359.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,329.66H263.46c5.84-10.12,7-18.2,7-18.2H354S355.14,319.54,361,329.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,329.66v2.15a1.91,1.91,0,0,1-1.81,2H355.3a1.91,1.91,0,0,1-1.82-2,1.91,1.91,0,0,1-1.81,2h-3.88a1.91,1.91,0,0,1-1.81-2,1.91,1.91,0,0,1-1.81,2h-3.88a1.91,1.91,0,0,1-1.81-2,1.91,1.91,0,0,1-1.81,2h-3.88a1.91,1.91,0,0,1-1.81-2,1.91,1.91,0,0,1-1.82,2h-3.87a1.91,1.91,0,0,1-1.81-2,1.91,1.91,0,0,1-1.82,2h-3.88a1.91,1.91,0,0,1-1.81-2,1.91,1.91,0,0,1-1.81,2h-3.88a1.91,1.91,0,0,1-1.81-2,1.91,1.91,0,0,1-1.81,2h-3.88a1.91,1.91,0,0,1-1.81-2,1.91,1.91,0,0,1-1.81,2h-3.88a1.91,1.91,0,0,1-1.81-2,1.91,1.91,0,0,1-1.82,2h-3.87a1.91,1.91,0,0,1-1.82-2,1.91,1.91,0,0,1-1.81,2h-3.87a1.91,1.91,0,0,1-1.82-2,1.91,1.91,0,0,1-1.81,2h-3.87a1.91,1.91,0,0,1-1.82-2,1.91,1.91,0,0,1-1.81,2h-3.88a1.91,1.91,0,0,1-1.81-2v-2.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,331.81c0-.72,0-1.44-.08-2.15v-.05c.84-1.38,1.59-2.82,2.29-4.28s1.31-2.95,1.89-4.46a44.15,44.15,0,0,0,1.42-4.63l.28-1.18c.08-.4.13-.8.21-1.2.18-.79.22-1.6.35-2.4a27.18,27.18,0,0,1-.55,4.84,34.55,34.55,0,0,1-1.34,4.7,42.5,42.5,0,0,1-1.94,4.49c-.36.73-.75,1.44-1.17,2.15s-.83,1.4-1.3,2.06v0C271,330.37,271,331.09,271,331.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.46,331.81c0-.72,0-1.44-.08-2.15v0l0,0c.41-.68.79-1.38,1.15-2.09s.68-1.44,1-2.17a37.39,37.39,0,0,0,1.59-4.49,11.53,11.53,0,0,0,.32-1.15c.09-.38.21-.77.28-1.16.16-.78.34-1.55.45-2.34a44.46,44.46,0,0,0,.5-4.75,29.55,29.55,0,0,1-.21,4.79,32.87,32.87,0,0,1-2.6,9.25,26.15,26.15,0,0,1-2.34,4.2l0,0C278.52,330.37,278.5,331.09,278.46,331.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.47,331.81c-.05-1.7-.05-3.39-.05-5.09s0-3.39.06-5.09.08-3.39.15-5.09l.11-2.54c.05-.85.09-1.7.15-2.54,0,.84,0,1.69.05,2.54v2.55c0,1.69,0,3.39-.06,5.09s-.09,3.39-.16,5.08S308.59,330.12,308.47,331.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,331.81c-.12-1.69-.19-3.39-.26-5.09s-.1-3.39-.15-5.08-.06-3.4-.06-5.09V314c0-.85,0-1.7.05-2.54.06.84.1,1.69.15,2.54l.11,2.54c.07,1.7.11,3.39.16,5.09s0,3.39.06,5.09S316,330.11,316,331.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,331.81c0-.72-.06-1.44-.09-2.15h0c.2-1.5.31-3,.44-4.53s.18-3,.27-4.54.12-3,.18-4.56l.13-4.55c.05.75.08,1.51.12,2.28s0,1.52,0,2.28c0,1.52,0,3-.07,4.56s-.18,3.05-.32,4.56c-.07.76-.16,1.52-.26,2.27s-.21,1.51-.36,2.26h0C301,330.37,301,331.09,301,331.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.47,331.81c0-.72-.06-1.44-.09-2.15v0a29.08,29.08,0,0,0,1.14-4.43c.14-.76.26-1.51.38-2.27s.2-1.52.29-2.28c.19-1.52.28-3.05.41-4.58l.14-2.3c0-.77.06-1.54.11-2.3,0,.76.05,1.53.07,2.3s0,1.54,0,2.31c0,1.54-.15,3.08-.31,4.61a44.45,44.45,0,0,1-.71,4.58c-.15.75-.34,1.5-.56,2.24a15.41,15.41,0,0,1-.78,2.19v0C293.52,330.37,293.5,331.09,293.47,331.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,331.81c0-.72,0-1.44-.08-2.15v-.05a28.86,28.86,0,0,0,1.68-4.34c.47-1.49.81-3,1.13-4.53s.52-3.07.7-4.62c.11-.77.13-1.55.22-2.32s.08-1.56.14-2.34c0,.78,0,1.56,0,2.34l0,1.18c0,.39,0,.78-.07,1.17l-.09,1.17c0,.4-.1.78-.15,1.17-.09.78-.23,1.55-.36,2.33a38.16,38.16,0,0,1-1.18,4.56c-.24.75-.52,1.48-.83,2.2a17.33,17.33,0,0,1-1,2.12v0C286,330.37,286,331.09,286,331.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.48,331.81c0-.72-.05-1.44-.08-2.15v0c-.47-.66-.89-1.36-1.3-2.06s-.81-1.42-1.17-2.15A42.5,42.5,0,0,1,349,321a33.13,33.13,0,0,1-1.33-4.7,25.46,25.46,0,0,1-.55-4.84c.12.8.17,1.61.34,2.4.08.4.13.8.22,1.2l.27,1.18a42,42,0,0,0,1.43,4.63c.57,1.51,1.17,3,1.88,4.46s1.45,2.9,2.29,4.28v.05C353.54,330.37,353.52,331.09,353.48,331.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,331.81c0-.72-.06-1.44-.08-2.15v0a26.15,26.15,0,0,1-2.34-4.2,31.82,31.82,0,0,1-1.64-4.53,30.38,30.38,0,0,1-1-4.72,29.55,29.55,0,0,1-.21-4.79,47.2,47.2,0,0,0,.5,4.75c.12.79.3,1.56.45,2.34.08.39.19.78.28,1.16s.2.77.32,1.15a37.39,37.39,0,0,0,1.59,4.49c.32.73.64,1.46,1,2.17s.75,1.41,1.16,2.09v.05C346,330.37,346,331.09,346,331.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.48,331.81c0-.72-.06-1.44-.09-2.15h0c-.15-.75-.25-1.5-.36-2.26s-.19-1.51-.26-2.27c-.13-1.51-.26-3-.31-4.56s-.11-3-.08-4.56c0-.76,0-1.52.05-2.28s.06-1.53.11-2.28l.13,4.55c.06,1.52.1,3,.18,4.56s.15,3,.28,4.54.23,3,.43,4.53h0C323.53,330.37,323.52,331.09,323.48,331.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,331.81c0-.72-.06-1.44-.09-2.15v0a15.41,15.41,0,0,1-.78-2.19c-.21-.74-.4-1.49-.56-2.24a44.42,44.42,0,0,1-.7-4.58c-.17-1.53-.28-3.07-.32-4.61l0-2.31c0-.77,0-1.54.07-2.3.05.76.08,1.53.12,2.3l.13,2.3c.13,1.53.22,3.06.42,4.58.08.76.19,1.52.29,2.28s.23,1.51.38,2.27a27.93,27.93,0,0,0,1.13,4.43v0C331,330.37,331,331.09,331,331.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.48,331.81c0-.72-.06-1.44-.08-2.15v0a17.33,17.33,0,0,1-1-2.12,21.59,21.59,0,0,1-.83-2.2,36.35,36.35,0,0,1-1.18-4.56c-.13-.78-.28-1.55-.37-2.33-.05-.39-.11-.77-.14-1.17l-.1-1.17q0-.58-.06-1.17l0-1.18c0-.78,0-1.56,0-2.34.06.78.09,1.56.15,2.34s.11,1.55.21,2.32c.18,1.55.4,3.1.7,4.62s.67,3,1.14,4.53a27.78,27.78,0,0,0,1.67,4.34v.05C338.54,330.37,338.52,331.09,338.48,331.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.01,
    y: 343.65,
    width: 48.41,
    height: 27.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.88,368.67H290.57v-22.4h43.31v22.4Zm-43.21-.1h43.1V346.38h-43.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.32,357.83a3.48,3.48,0,0,1,3.51-3.39,3.59,3.59,0,0,1,2.22.73.55.55,0,0,1,.09.75.56.56,0,0,1-.76.11,2.44,2.44,0,0,0-1.55-.52,2.52,2.52,0,0,0-1.72.68,2.27,2.27,0,0,0,0,3.28,2.58,2.58,0,0,0,1.73.68,2.43,2.43,0,0,0,1.54-.52.57.57,0,0,1,.76.1.54.54,0,0,1-.09.75,3.59,3.59,0,0,1-2.21.74A3.48,3.48,0,0,1,293.32,357.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.9,360.7v-5.56a.53.53,0,0,1,.53-.52.53.53,0,0,1,.53.52v5h2.59a.53.53,0,1,1,0,1.05h-3.13A.53.53,0,0,1,300.9,360.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.1,355.44a3.44,3.44,0,0,1,0,4.77,3.18,3.18,0,0,1-2.29,1,3.29,3.29,0,0,1-2.35-1,3.47,3.47,0,0,1,0-4.77,3.25,3.25,0,0,1,2.35-1A3.15,3.15,0,0,1,311.1,355.44Zm-.13,2.38a2.4,2.4,0,0,0-.65-1.64,2.08,2.08,0,0,0-3.06,0,2.32,2.32,0,0,0-.65,1.65,2.36,2.36,0,0,0,.65,1.64,2.11,2.11,0,0,0,1.55.67,2.07,2.07,0,0,0,1.51-.68A2.36,2.36,0,0,0,311,357.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.59,359.58a.5.5,0,0,1,.7-.07,3.14,3.14,0,0,0,1.83.73,2.16,2.16,0,0,0,1.2-.35.88.88,0,0,0,.41-.68.51.51,0,0,0-.09-.3.84.84,0,0,0-.28-.29,3.81,3.81,0,0,0-1.32-.44h0a4.92,4.92,0,0,1-1.23-.37,2.06,2.06,0,0,1-.89-.73,1.47,1.47,0,0,1-.22-.77,1.73,1.73,0,0,1,.76-1.38,2.88,2.88,0,0,1,1.66-.5,3.81,3.81,0,0,1,2.09.75.48.48,0,0,1,.13.67.48.48,0,0,1-.68.14,2.81,2.81,0,0,0-1.54-.6,1.84,1.84,0,0,0-1.07.32.76.76,0,0,0-.37.6.44.44,0,0,0,.07.26.88.88,0,0,0,.26.24,3.24,3.24,0,0,0,1.2.42h0a6.19,6.19,0,0,1,1.32.39,2.33,2.33,0,0,1,1,.79,1.52,1.52,0,0,1,.22.8,1.79,1.79,0,0,1-.82,1.46,3,3,0,0,1-1.77.54,4.15,4.15,0,0,1-2.45-.95A.49.49,0,0,1,313.59,359.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.09,360.7v-5.56a.51.51,0,0,1,.53-.52h3.13a.52.52,0,0,1,.52.52.52.52,0,0,1-.52.52h-2.6v1.73h2.24a.53.53,0,0,1,.52.52.52.52,0,0,1-.52.52h-2.24v1.74h2.59a.52.52,0,1,1,0,1h-3.13A.52.52,0,0,1,320.09,360.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.67,360.7v-5.57a.51.51,0,0,1,.53-.51h1.13a3.3,3.3,0,1,1,0,6.59H326.2A.52.52,0,0,1,325.67,360.7Zm1.06-.53h.6a2.26,2.26,0,1,0,0-4.51h-.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.88,406.79c-.08-1.14-.11-2.27-.16-3.4s-.08-2.26-.12-3.4c-.06-2.26-.09-4.53-.12-6.79v-.39h.4c1.77,0,3.55,0,5.33,0s3.55,0,5.33,0,3.55.07,5.33.13c.89,0,1.78.07,2.66.1l2.67.13c-.89.06-1.78.09-2.67.13s-1.77.08-2.66.1c-1.78.06-3.56.1-5.33.13s-3.56,0-5.33,0-3.56,0-5.33,0l.39-.39c0,2.26-.06,4.53-.12,6.79,0,1.14-.06,2.27-.12,3.4S271,405.65,270.88,406.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5,393.2c.07,1.13.11,2.26.16,3.4s.08,2.26.11,3.39c.06,2.27.09,4.53.12,6.8v.39h-.39c-1.8,0-3.59,0-5.39,0s-3.59,0-5.38-.05-3.59-.06-5.39-.12l-2.69-.11-2.7-.12c.9-.06,1.8-.1,2.7-.13l2.69-.11c1.8-.06,3.59-.09,5.39-.12s3.59-.05,5.38-.05,3.59,0,5.39,0l-.39.4c0-2.27.05-4.53.11-6.8,0-1.13.07-2.26.12-3.39S294.43,394.33,294.5,393.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M273.94,404.22c-.06-1.41-.11-2.82-.13-4.23l0-2.11c0-.71,0-1.41,0-2.12v-.18h.19l3.95,0,3.95,0c1.31,0,2.63,0,3.94.06s2.64.07,4,.12c-1.31.05-2.63.1-4,.12s-2.63.06-3.94.06l-3.95,0-3.95,0,.18-.18c0,.71,0,1.41,0,2.12l0,2.11C274,401.4,274,402.81,273.94,404.22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M291.44,395.76c.05,1.41.1,2.82.12,4.23s.06,2.82.06,4.23v.18h-.18l-4,0-4,0c-1.33,0-2.66,0-4-.06s-2.66-.06-4-.12c1.33-.05,2.66-.09,4-.11s2.66-.07,4-.07l4,0,4,0-.19.18c0-1.41,0-2.82.06-4.23S291.38,397.17,291.44,395.76Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M303.47,404.22c-.05-1.41-.1-2.82-.12-4.23l0-2.11c0-.71,0-1.41,0-2.12v-.18h.18l3.95,0,3.95,0c1.32,0,2.63,0,3.95.06l3.95.12c-1.32.05-2.64.1-3.95.12s-2.63.06-3.95.06l-3.95,0-3.95,0,.18-.18c0,.71,0,1.41,0,2.12l0,2.11C303.57,401.4,303.52,402.81,303.47,404.22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M321,395.76c0,1.41.1,2.82.12,4.23s.06,2.82.06,4.23v.18H321l-4,0-4,0c-1.33,0-2.66,0-4-.06s-2.66-.06-4-.12c1.33-.05,2.66-.09,4-.11s2.66-.07,4-.07l4,0,4,0-.18.18c0-1.41,0-2.82.06-4.23S320.92,397.17,321,395.76Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M300.41,406.79c-.07-1.14-.11-2.27-.16-3.4s-.08-2.26-.11-3.4c-.06-2.26-.1-4.53-.12-6.79v-.39h.4c1.78,0,3.56,0,5.33,0s3.56,0,5.33,0,3.56.07,5.33.13c.89,0,1.78.07,2.67.1l2.66.13c-.88.06-1.77.09-2.66.13s-1.78.08-2.67.1c-1.77.06-3.55.1-5.33.13s-3.55,0-5.33,0-3.55,0-5.33,0l.39-.39c0,2.26-.06,4.53-.11,6.79,0,1.14-.07,2.27-.12,3.4S300.48,405.65,300.41,406.79Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M324,393.2c.07,1.13.11,2.26.16,3.4s.08,2.26.12,3.39c.06,2.27.09,4.53.12,6.8v.39H324c-1.79,0-3.59,0-5.38,0s-3.59,0-5.39-.05-3.59-.06-5.38-.12l-2.7-.11c-.9,0-1.79-.07-2.69-.12.9-.06,1.79-.1,2.69-.13l2.7-.11c1.79-.06,3.59-.09,5.38-.12s3.59-.05,5.39-.05,3.59,0,5.38,0l-.39.4c0-2.27.06-4.53.12-6.8,0-1.13.06-2.26.11-3.39S324,394.33,324,393.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M333,404.22c-.05-1.41-.1-2.82-.12-4.23l0-2.11c0-.71,0-1.41,0-2.12v-.18H333l3.95,0,3.95,0c1.32,0,2.63,0,4,.06s2.63.07,3.95.12c-1.32.05-2.63.1-3.95.12s-2.63.06-4,.06L337,396l-3.95,0,.19-.18c0,.71,0,1.41,0,2.12l0,2.11C333.1,401.4,333.06,402.81,333,404.22Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M350.5,395.76c.06,1.41.1,2.82.13,4.23s.05,2.82.06,4.23v.18h-.19l-4,0-4,0c-1.33,0-2.66,0-4-.06s-2.66-.06-4-.12c1.33-.05,2.66-.09,4-.11s2.66-.07,4-.07l4,0,4,0-.18.18c0-1.41,0-2.82.06-4.23S350.45,397.17,350.5,395.76Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M330,406.79c-.07-1.14-.11-2.27-.16-3.4s-.08-2.26-.12-3.4c-.06-2.26-.09-4.53-.12-6.79v-.39h.4c1.77,0,3.55,0,5.33,0s3.55,0,5.33,0,3.55.07,5.33.13c.89,0,1.78.07,2.66.1l2.67.13c-.89.06-1.78.09-2.67.13s-1.77.08-2.66.1c-1.78.06-3.55.1-5.33.13s-3.56,0-5.33,0-3.56,0-5.33,0l.39-.39c0,2.26-.06,4.53-.12,6.79,0,1.14-.06,2.27-.11,3.4S330,405.65,330,406.79Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M353.57,393.2c.07,1.13.11,2.26.16,3.4s.08,2.26.11,3.39c.06,2.27.1,4.53.12,6.8v.39h-.39c-1.8,0-3.59,0-5.39,0s-3.59,0-5.38-.05-3.59-.06-5.39-.12l-2.69-.11-2.7-.12c.9-.06,1.8-.1,2.7-.13l2.69-.11c1.8-.06,3.59-.09,5.39-.12s3.59-.05,5.38-.05,3.59,0,5.39,0l-.39.4c0-2.27.05-4.53.11-6.8,0-1.13.07-2.26.12-3.39S353.5,394.33,353.57,393.2Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-1--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.88,
    y: 236.9,
    width: 201.29,
    height: 179.85,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.88,
    y: 236.9,
    width: 201.29,
    height: 66.46,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.54,
    y: 393.42,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 398.71,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.08,
    y: 398.71,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.58,
    y: 398.71,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.58,
    y: 331.78,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.13,
    y: 337.08,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 331.79,
    width: 9.93,
    height: 4.2,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.56,
    y: 359.07,
    width: 9.93,
    height: 4.2,
    transform: "translate(337.04 722.33) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.1,
    y: 353.77,
    width: 9.93,
    height: 4.2,
    transform: "translate(348.12 711.74) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.36,
    y: 250.93,
    width: 26.91,
    height: 41.21,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.56,
    y: 253.12,
    width: 22.53,
    height: 36.82,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "104.08 253.12 104.08 257.56 81.56 280.09 81.56 269.41 97.85 253.12 104.08 253.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.08 276.4 104.08 287.06 101.21 289.94 90.54 289.94 104.08 276.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.08 271.72 104.08 273.97 88.11 289.94 85.86 289.94 104.08 271.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.58 253.12 81.56 267.14 81.56 262.73 91.17 253.12 95.58 253.12",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 81.56,
    y: 263.67,
    width: 22.53,
    height: 2.19,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.88,
    y: 250.93,
    width: 26.91,
    height: 41.21,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.07,
    y: 253.12,
    width: 22.53,
    height: 36.82,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "141.6 253.12 141.6 257.56 119.07 280.09 119.07 269.41 135.37 253.12 141.6 253.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.6 276.4 141.6 287.06 138.73 289.94 128.06 289.94 141.6 276.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.6 271.72 141.6 273.97 125.63 289.94 123.38 289.94 141.6 271.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.1 253.12 119.07 267.14 119.07 262.73 128.69 253.12 133.1 253.12",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 119.07,
    y: 263.67,
    width: 22.53,
    height: 2.19,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.05,
    y: 250.93,
    width: 26.91,
    height: 41.21,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.24,
    y: 253.12,
    width: 22.53,
    height: 36.82,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "206.77 253.12 206.77 257.56 184.24 280.09 184.24 269.41 200.53 253.12 206.77 253.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.77 276.4 206.77 287.06 203.89 289.94 193.22 289.94 206.77 276.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.77 271.72 206.77 273.97 190.79 289.94 188.54 289.94 206.77 271.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.27 253.12 184.24 267.14 184.24 262.73 193.85 253.12 198.27 253.12",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 184.24,
    y: 263.67,
    width: 22.53,
    height: 2.19,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.57,
    y: 250.93,
    width: 26.91,
    height: 41.21,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.76,
    y: 253.12,
    width: 22.53,
    height: 36.82,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "244.29 253.12 244.29 257.56 221.76 280.09 221.76 269.41 238.05 253.12 244.29 253.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.29 276.4 244.29 287.06 241.41 289.94 230.74 289.94 244.29 276.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.29 271.72 244.29 273.97 228.31 289.94 226.06 289.94 244.29 271.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.78 253.12 221.76 267.14 221.76 262.73 231.37 253.12 235.78 253.12",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 221.76,
    y: 263.67,
    width: 22.53,
    height: 2.19,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.71,
    y: 412.56,
    width: 207.64,
    height: 4.18,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.71,
    y: 236.93,
    width: 207.64,
    height: 4.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.47,
    y: 338.14,
    width: 34.23,
    height: 78.6,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.32,
    y: 343.99,
    width: 22.53,
    height: 36.82,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "205.84 343.99 205.84 348.43 183.31 370.96 183.31 360.29 199.61 343.99 205.84 343.99",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.84 367.27 205.84 377.94 202.97 380.81 192.3 380.81 205.84 367.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.84 362.59 205.84 364.84 189.87 380.81 187.62 380.81 205.84 362.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.34 343.99 183.31 358.02 183.31 353.6 192.93 343.99 197.34 343.99",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 207.36,
    y: 384.31,
    width: 2.07,
    height: 9.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.27,
    y: 338.14,
    width: 34.23,
    height: 78.6,
    transform: "translate(458.77 754.88) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.12,
    y: 343.99,
    width: 22.53,
    height: 36.82,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "218.12 343.99 218.12 348.43 240.65 370.96 240.65 360.29 224.35 343.99 218.12 343.99",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.12 367.27 218.12 377.94 221 380.81 231.67 380.81 218.12 367.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.12 362.59 218.12 364.84 234.09 380.81 236.34 380.81 218.12 362.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.62 343.99 240.65 358.02 240.65 353.6 231.04 343.99 226.62 343.99",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 214.53,
    y: 384.31,
    width: 2.07,
    height: 9.07,
    transform: "translate(431.13 777.69) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.9,
    y: 218.31,
    width: 175.25,
    height: 18.59,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.51,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.08,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.65,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.22,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.79,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.36,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.92,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.49,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.06,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.63,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.2,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.77,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.34,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.91,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.48,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.05,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.62,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.19,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.76,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.32,
    y: 221.64,
    width: 3.22,
    height: 12.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.39,357.16v32.48h-38V357.16a19,19,0,1,1,38,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2,357.16v30.29H81.56V357.16a16.82,16.82,0,1,1,33.64,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.21,357.16v30.29H81.56V357.16a16.8,16.8,0,0,1,16.82-16.83c.54,0,1.07,0,1.59.08a16.81,16.81,0,0,1,12.82,8.07,15.9,15.9,0,0,1,1.47,3.12,12.91,12.91,0,0,1,.53,1.84A16.32,16.32,0,0,1,115.21,357.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.56,
    y: 356.85,
    width: 33.65,
    height: 2.19,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.65,
    y: 347.16,
    width: 17.21,
    height: 2.19,
    transform: "translate(440.51 256) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 347.16,
    width: 17.21,
    height: 2.19,
    transform: "translate(452.75 243.75) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.79,348.48,81.56,379.7V368.52l25.67-25.67A16.73,16.73,0,0,1,112.79,348.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.79,353.44,81.56,386.67V384.3l32.7-32.7A12.91,12.91,0,0,1,114.79,353.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,340.41,81.56,358.82v-1.66a17,17,0,0,1,.32-3.29L95.1,340.65a16.89,16.89,0,0,1,3.28-.32C98.92,340.33,99.45,340.36,100,340.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.22,357.16v32.48h-38V357.16a19,19,0,1,1,38,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,357.16v30.29H128.38V357.16a16.83,16.83,0,1,1,33.65,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,357.16v30.29H128.38V357.16a16.8,16.8,0,0,1,16.82-16.83c.54,0,1.07,0,1.59.08a16.81,16.81,0,0,1,12.82,8.07,15.9,15.9,0,0,1,1.47,3.12,12.91,12.91,0,0,1,.53,1.84A16.32,16.32,0,0,1,162,357.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.38,
    y: 356.85,
    width: 33.65,
    height: 2.19,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.47,
    y: 347.16,
    width: 17.21,
    height: 2.19,
    transform: "translate(487.33 209.17) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.72,
    y: 347.16,
    width: 17.21,
    height: 2.19,
    transform: "translate(499.58 196.93) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.61,348.48,128.38,379.7V368.52l25.67-25.67A16.73,16.73,0,0,1,159.61,348.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.61,353.44l-33.23,33.23V384.3l32.7-32.7A12.91,12.91,0,0,1,161.61,353.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.79,340.41l-18.41,18.41v-1.66a17,17,0,0,1,.32-3.29l13.22-13.22a16.89,16.89,0,0,1,3.28-.32C145.74,340.33,146.27,340.36,146.79,340.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 187.78,
    y: 351.51,
    width: 48.41,
    height: 27.66,
    transform: "translate(-61.26 43.24) rotate(-10.19)",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.28,372.52h-.05l-42.58,7.65v-.05l-3.95-22h.05l42.58-7.65v0Zm-42.55,7.54,42.43-7.62-3.93-21.84-42.42,7.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.44,369a3.49,3.49,0,0,1,2.86-4,3.61,3.61,0,0,1,2.31.33.56.56,0,0,1,.23.73.57.57,0,0,1-.74.23,2.37,2.37,0,0,0-1.61-.23,2.47,2.47,0,0,0-1.57,1,2.27,2.27,0,0,0,.58,3.23,2.56,2.56,0,0,0,1.81.36,2.47,2.47,0,0,0,1.43-.78.58.58,0,0,1,.77,0,.56.56,0,0,1,0,.76,3.64,3.64,0,0,1-2.05,1.12A3.48,3.48,0,0,1,193.44,369Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.41,370.51l-1-5.48a.52.52,0,0,1,.43-.6.53.53,0,0,1,.62.42l.89,4.95,2.55-.46a.53.53,0,0,1,.61.43.53.53,0,0,1-.43.6l-3,.55h0A.51.51,0,0,1,201.41,370.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.52,363.53a3.48,3.48,0,0,1,1.37,2.17,3.43,3.43,0,0,1-.53,2.52,3.2,3.2,0,0,1-2.07,1.4,3.26,3.26,0,0,1-2.49-.58,3.45,3.45,0,0,1-.84-4.69,3.17,3.17,0,0,1,2.13-1.41A3.13,3.13,0,0,1,210.52,363.53Zm.3,2.37a2.47,2.47,0,0,0-.94-1.51,2.06,2.06,0,0,0-1.6-.39,2.08,2.08,0,0,0-1.41.93,2.41,2.41,0,0,0-.35,1.74,2.32,2.32,0,0,0,.93,1.5,2.13,2.13,0,0,0,1.65.39,2.1,2.1,0,0,0,1.36-.93A2.38,2.38,0,0,0,210.82,365.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.71,367.16a.49.49,0,0,1,.67-.19,3.15,3.15,0,0,0,1.93.39,2.12,2.12,0,0,0,1.12-.55.87.87,0,0,0,.28-.74.53.53,0,0,0-.14-.29.79.79,0,0,0-.33-.22,4,4,0,0,0-1.37-.21h0a5.17,5.17,0,0,1-1.28-.15,2.1,2.1,0,0,1-1-.56,1.48,1.48,0,0,1-.35-.72,1.75,1.75,0,0,1,.51-1.49,2.85,2.85,0,0,1,1.54-.79,3.8,3.8,0,0,1,2.19.37.49.49,0,0,1,.25.64.48.48,0,0,1-.64.26,2.76,2.76,0,0,0-1.63-.32,1.79,1.79,0,0,0-1,.5.75.75,0,0,0-.26.65.48.48,0,0,0,.11.25,1.3,1.3,0,0,0,.3.19,3.19,3.19,0,0,0,1.25.2h0a5.33,5.33,0,0,1,1.37.15,2.25,2.25,0,0,1,1.08.6,1.52,1.52,0,0,1,.37.75,1.79,1.79,0,0,1-.55,1.58,3,3,0,0,1-1.65.85,4.19,4.19,0,0,1-2.58-.5A.48.48,0,0,1,213.71,367.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.3,367.11l-1-5.47a.51.51,0,0,1,.42-.6h0l3-.55a.53.53,0,0,1,.61.42.52.52,0,0,1-.42.61l-2.55.46.3,1.7,2.2-.39a.52.52,0,0,1,.61.41.53.53,0,0,1-.43.61l-2.19.4.3,1.71,2.56-.46a.54.54,0,0,1,.61.42.55.55,0,0,1-.43.61l-3.05.55h0A.52.52,0,0,1,220.3,367.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.79,366.13l-1-5.48a.51.51,0,0,1,.43-.6l1.11-.2a3.3,3.3,0,1,1,1.16,6.49l-1.11.2A.52.52,0,0,1,225.79,366.13Zm1-.71.59-.11a2.25,2.25,0,1,0-.8-4.43L226,361Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.88,
    y: 303.36,
    width: 200.86,
    height: 24.22,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.87,315.24v0a1.7,1.7,0,0,1,3.39,0v0a1.7,1.7,0,0,1-3.39,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.81,317.88a1.73,1.73,0,0,0-.78-1.45,3.17,3.17,0,0,0-1.11-.48l-.07,0h-2.33v3.79a.34.34,0,0,1-.67,0v-8.92a.35.35,0,0,1,.3-.33h2.74a2.74,2.74,0,0,1,1.15,5.22l.14.07a2.4,2.4,0,0,1,1.28,2.13,3.6,3.6,0,0,0,.13,1.11.5.5,0,0,0,.13.23.36.36,0,0,1,.37.22.37.37,0,0,1-.21.44h-.2a.75.75,0,0,1-.61-.44A3.27,3.27,0,0,1,126.81,317.88Zm-1.92-6.75h-2.37v4.14H125a2.07,2.07,0,0,0-.06-4.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.47,310.79a.33.33,0,0,1,.32-.33h4.93a.34.34,0,0,1,0,.67h-4.58v3.79h4a.34.34,0,0,1,.33.35.34.34,0,0,1-.33.32h-4v3.78h4.58a.34.34,0,0,1,0,.67h-4.95a.32.32,0,0,1-.3-.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,318.25a.29.29,0,0,1,.43,0,5.29,5.29,0,0,0,3.14,1.23,3.62,3.62,0,0,0,2.11-.63,1.77,1.77,0,0,0,.82-1.42,1.54,1.54,0,0,0-.78-1.32,6.34,6.34,0,0,0-2.22-.78h0a6.08,6.08,0,0,1-2.26-.8,2,2,0,0,1-1-1.67,2.25,2.25,0,0,1,1-1.8,3.91,3.91,0,0,1,2.32-.69,5.31,5.31,0,0,1,2.95,1.1.31.31,0,0,1,.08.43.28.28,0,0,1-.41.08,4.75,4.75,0,0,0-2.62-1,3.45,3.45,0,0,0-2,.57,1.67,1.67,0,0,0-.75,1.32,1.38,1.38,0,0,0,.71,1.16,5.66,5.66,0,0,0,2.05.73h0a6.44,6.44,0,0,1,2.43.87,2.16,2.16,0,0,1,1.06,1.81,2.41,2.41,0,0,1-1.08,1.91,4.21,4.21,0,0,1-2.47.76,6,6,0,0,1-3.53-1.39A.31.31,0,0,1,138,318.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.72,311.13h-2.89a.34.34,0,0,1,0-.67h6.43a.34.34,0,0,1,0,.67h-2.89v8.58a.33.33,0,1,1-.65,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.92,317.57h-4.37l-.85,2.25a.32.32,0,0,1-.31.22h-.12a.36.36,0,0,1-.2-.44l3.33-8.88a.35.35,0,0,1,.33-.21.33.33,0,0,1,.33.21l3.32,8.88a.34.34,0,0,1-.18.44h-.12a.34.34,0,0,1-.31-.22Zm-4.12-.68h3.87l-1.93-5.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.06,310.79a.33.33,0,0,1,.32-.33.34.34,0,0,1,.35.33v5.38a3.2,3.2,0,1,0,6.4,0v-5.38a.34.34,0,0,1,.67,0v5.38a3.87,3.87,0,1,1-7.74,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.47,317.88a1.7,1.7,0,0,0-.78-1.45,3.09,3.09,0,0,0-1.11-.48l-.06,0h-2.33v3.79a.34.34,0,0,1-.67,0v-8.92a.35.35,0,0,1,.3-.33h2.74a2.74,2.74,0,0,1,1.15,5.22l.13.07a2.41,2.41,0,0,1,1.29,2.13,4.07,4.07,0,0,0,.12,1.11.57.57,0,0,0,.14.23.36.36,0,0,1,.37.22.37.37,0,0,1-.22.44h-.19a.75.75,0,0,1-.62-.44A3.4,3.4,0,0,1,178.47,317.88Zm-1.91-6.75h-2.37v4.14h2.42a2.07,2.07,0,0,0-.05-4.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.37,317.57H183l-.85,2.25a.34.34,0,0,1-.32.22h-.12a.35.35,0,0,1-.19-.44l3.32-8.88a.37.37,0,0,1,.33-.21.33.33,0,0,1,.33.21l3.33,8.88a.35.35,0,0,1-.18.44h-.12a.35.35,0,0,1-.32-.22Zm-4.12-.68h3.88l-1.93-5.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.54,311.87v7.84a.33.33,0,1,1-.66,0v-8.78a.33.33,0,0,1,.12-.37.34.34,0,0,1,.47.08l5.8,8.05v-7.8a.34.34,0,0,1,.67,0v8.82a.34.34,0,0,1-.34.33.32.32,0,0,1-.26-.12l-.05-.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.6,311.13h-2.89a.34.34,0,0,1,0-.67h6.44a.34.34,0,0,1,0,.67h-2.89v8.58a.33.33,0,1,1-.66,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.93,315.24v0a1.7,1.7,0,0,1,3.39,0v0a1.7,1.7,0,0,1-3.39,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.88,
    y: 323.25,
    width: 200.86,
    height: 0.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.88,
    y: 307.2,
    width: 200.86,
    height: 0.5,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.21,416.78h37s-.09-5.51-3.73-7a5,5,0,0,0-5.81,1.4s-1.48-10.14-8.27-10.14-10,8.74-10,8.74a5.2,5.2,0,0,0-5.28-2.15C247.36,408.15,247.21,416.78,247.21,416.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.09,416.78s-1.51-7-4.52-8.13-4.85,2.08-4.85,2.08-.71-6.73-5-8.74-7.48,2.11-7.48,2.11-3.28-8.54-9.14-8.54-8.81,12.49-8.81,12.49-3.46-3.72-7-1.62-3.55,10.35-3.55,10.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.61,416.78h34.15s-1.12-4.81-3.39-5.16a3.35,3.35,0,0,0-3.32,1.9s.11-6.72-4.12-7.86-7.78,4.79-7.78,4.79-2.65-3.39-6.27-3.17-4.53,5.81-4.53,5.81S279.06,411.15,277.61,416.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.67,416.78H584.78s.06-4.15,2.8-5.25a3.73,3.73,0,0,1,4.37,1.05s1.12-7.64,6.23-7.64,7.56,6.59,7.56,6.59a3.91,3.91,0,0,1,4-1.62C612.55,410.28,612.67,416.78,612.67,416.78Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--fire-hydrant--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.59,
    y: 399.08,
    width: 9.51,
    height: 17.66,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.96,
    y: 398.39,
    width: 10.77,
    height: 0.7,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.96,
    y: 397.24,
    width: 10.77,
    height: 0.7,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.59,
    y: 397.94,
    width: 9.51,
    height: 0.45,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.59,
    y: 397.94,
    width: 9.51,
    height: 0.45,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.09,397.24H122.6a4.75,4.75,0,0,1,9.49,0Z",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.09,397.24H122.6a4,4,0,0,1,.07-.59l9.2-.6A4.32,4.32,0,0,1,132.09,397.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.1 399.08 132.1 400.13 122.59 400.57 122.59 399.08 132.1 399.08",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.65,
    y: 401.44,
    width: 0.82,
    height: 14.22,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.29,
    y: 401.44,
    width: 0.82,
    height: 14.22,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.94,
    y: 401.44,
    width: 0.82,
    height: 14.22,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.58,
    y: 401.44,
    width: 0.82,
    height: 14.22,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.22,
    y: 401.44,
    width: 0.82,
    height: 14.22,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.91,
    y: 402.44,
    width: 1.68,
    height: 4.36,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.27,
    y: 402.81,
    width: 0.64,
    height: 3.73,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.27,
    y: 402.81,
    width: 0.64,
    height: 3.73,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.27,403.58v2.08a1,1,0,0,1,0-2.08Z",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.59 402.44 122.59 406.8 122.2 406.8 121.51 402.44 122.59 402.44",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.1,
    y: 402.44,
    width: 1.68,
    height: 4.36,
    transform: "translate(265.88 809.24) rotate(180)",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.78,
    y: 402.81,
    width: 0.64,
    height: 3.73,
    transform: "translate(268.2 809.35) rotate(180)",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.78,
    y: 402.81,
    width: 0.64,
    height: 3.73,
    transform: "translate(268.2 809.35) rotate(180)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.42,403.58v2.08a1,1,0,0,0,0-2.08Z",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.1 402.44 132.1 406.8 132.49 406.8 133.18 402.44 132.1 402.44",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.35,
    cy: 404.62,
    r: 3.28,
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.6,404.62a2.26,2.26,0,1,1-2.25-2.25A2.25,2.25,0,0,1,129.6,404.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.03,
    y: 390.94,
    width: 0.64,
    height: 3.73,
    transform: "translate(520.15 265.46) rotate(90)",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.03,
    y: 390.94,
    width: 0.64,
    height: 3.73,
    transform: "translate(520.15 265.46) rotate(90)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.44,392.49h-2.08a1,1,0,0,1,2.08,0Z",
    style: {
      fill: "#66768D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trash-can--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "533.16 384.53 532.91 389.41 531.78 417.11 512.07 417.11 510.94 389.41 510.69 384.53 533.16 384.53",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "533.16 384.53 532.91 389.41 510.94 389.41 510.69 384.53 533.16 384.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M514.14,390.79a.5.5,0,0,0-.49.5v5.43l.08,6.2.07,6.21,0,3.11v2.32a.28.28,0,1,0,.56,0v-2.32l0-3.11.08-6.21.07-6.2,0-3.11v-2.32A.49.49,0,0,0,514.14,390.79Zm0,0a.5.5,0,0,1,.5.5v2.32l0,3.11.07,6.2.08,6.21v5.43a.71.71,0,0,1-.71.71.7.7,0,0,1-.7-.71v-2.32l0-3.11.07-6.21.08-6.2v-5.43A.49.49,0,0,1,514.14,390.79Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M516.74,390.79a.49.49,0,0,0-.49.5v2.32l0,3.11.07,6.2.08,6.21v5.43a.27.27,0,0,0,.28.28.28.28,0,0,0,.28-.28v-5.43l.08-6.21.08-6.2v-5.43A.49.49,0,0,0,516.74,390.79Zm0,0a.49.49,0,0,1,.49.5v2.32l0,3.11.08,6.2.07,6.21,0,3.11v2.32a.7.7,0,0,1-.7.71.71.71,0,0,1-.71-.71v-2.32l0-3.11.08-6.21.07-6.2,0-3.11v-2.32A.5.5,0,0,1,516.74,390.79Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M519.33,390.79a.5.5,0,0,0-.49.5v2.32l0,3.11.08,6.2.07,6.21,0,3.11v2.32a.28.28,0,0,0,.56,0v-2.32l0-3.11.07-6.21.08-6.2,0-3.11v-2.32A.5.5,0,0,0,519.33,390.79Zm0,0a.51.51,0,0,1,.5.5v5.43l.08,6.2.08,6.21v5.43a.71.71,0,0,1-.71.71.7.7,0,0,1-.7-.71v-5.43l.08-6.21.08-6.2v-5.43A.51.51,0,0,1,519.33,390.79Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M521.92,390.79a.49.49,0,0,0-.48.5v5.43l.08,6.2.08,6.21v5.43a.28.28,0,0,0,.28.28.27.27,0,0,0,.28-.28v-5.43l.08-6.21.08-6.2v-5.43A.49.49,0,0,0,521.92,390.79Zm0,0a.5.5,0,0,1,.5.5v2.32l0,3.11.08,6.2.07,6.21,0,3.11v2.32a.71.71,0,1,1-1.41,0v-2.32l0-3.11.08-6.21.07-6.2,0-3.11v-2.32A.49.49,0,0,1,521.92,390.79Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M524.52,390.79a.49.49,0,0,0-.49.5v2.32l0,3.11.07,6.2.08,6.21,0,3.11v2.32a.28.28,0,0,0,.56,0v-2.32l0-3.11.07-6.21.08-6.2,0-3.11v-2.32A.5.5,0,0,0,524.52,390.79Zm0,0a.51.51,0,0,1,.5.5v5.43l.08,6.2.08,6.21v5.43a.7.7,0,1,1-1.4,0v-5.43l.08-6.21.08-6.2v-5.43A.51.51,0,0,1,524.52,390.79Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M527.11,390.79a.49.49,0,0,0-.48.5v5.43l.08,6.2.08,6.21v5.43a.28.28,0,0,0,.28.28.27.27,0,0,0,.28-.28v-5.43l.08-6.21.07-6.2,0-3.11v-2.32A.49.49,0,0,0,527.11,390.79Zm0,0a.5.5,0,0,1,.5.5v2.32l0,3.11.07,6.2.08,6.21,0,3.11v2.32a.71.71,0,0,1-.71.71.7.7,0,0,1-.7-.71v-2.32l0-3.11.07-6.21.08-6.2,0-3.11v-2.32A.49.49,0,0,1,527.11,390.79Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M529.71,390.79a.49.49,0,0,0-.49.5v2.32l0,3.11.07,6.2.08,6.21,0,3.11v2.32a.27.27,0,0,0,.28.28.27.27,0,0,0,.28-.28v-2.32l0-3.11.07-6.21.08-6.2v-5.43A.5.5,0,0,0,529.71,390.79Zm0,0a.49.49,0,0,1,.49.5v5.43l.08,6.2.08,6.21v5.43a.7.7,0,0,1-.7.71.71.71,0,0,1-.71-.71v-5.43l.08-6.21.07-6.2,0-3.11v-2.32A.5.5,0,0,1,529.71,390.79Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "526.22 379.4 526.22 382.82 524.91 382.82 524.91 380.56 518.94 380.56 518.94 382.82 517.63 382.82 517.63 379.4 526.22 379.4",
    style: {
      fill: "#66768D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.63,
    y: 381.33,
    width: 1.31,
    height: 1.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.91,
    y: 381.33,
    width: 1.31,
    height: 1.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509.21,
    y: 382.13,
    width: 25.42,
    height: 3.95,
    style: {
      fill: "#66768D"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStore);
export default __webpack_public_path__ + "static/media/empty-store.fb65d7123c4d5814a84eddf6847ead14.svg";
export { ForwardRef as ReactComponent };